webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(141)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(221),
  /* scopeId */
  "data-v-7d7be0ad",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(137)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(69),
  /* template */
  __webpack_require__(217),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(134)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(72),
  /* template */
  __webpack_require__(214),
  /* scopeId */
  "data-v-4337e18e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(133)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(79),
  /* template */
  __webpack_require__(213),
  /* scopeId */
  "data-v-42eeb338",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/gift-compressed.dbc98ee.png";

/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/playtotype-logos.d10492e.png";

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hatopress-whitechapel-closeup.b6bc9b8.jpg";

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hatopress-whitechapel.5ed6701.jpg";

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(130)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(73),
  /* template */
  __webpack_require__(210),
  /* scopeId */
  "data-v-3d86dd1c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(138)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(218),
  /* scopeId */
  "data-v-73439d73",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_WorkshopsRegular__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_WorkshopsRegular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_WorkshopsRegular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_WorkshopsCourses__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_WorkshopsCourses___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_WorkshopsCourses__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_WorkshopsBespoke__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_WorkshopsBespoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_WorkshopsBespoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_WorkshopsStrategy__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_WorkshopsStrategy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_WorkshopsStrategy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_WorkshopsPlaytotype__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_WorkshopsPlaytotype___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_WorkshopsPlaytotype__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_WorkshopsExperiential__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_WorkshopsExperiential___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_WorkshopsExperiential__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ChristmasWorkshops__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ChristmasWorkshops___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_ChristmasWorkshops__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ChristmasCampaign__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ChristmasCampaign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_ChristmasCampaign__);














__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  base: '/',
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home___default.a,
    children: [{
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_3__components_WorkshopsRegular___default.a
    }, {
      path: 'courses',
      component: __WEBPACK_IMPORTED_MODULE_4__components_WorkshopsCourses___default.a
    }, {
      path: 'private',
      component: __WEBPACK_IMPORTED_MODULE_5__components_WorkshopsBespoke___default.a,
      redirect: 'play'
    }, {
      path: 'strategy',
      component: __WEBPACK_IMPORTED_MODULE_6__components_WorkshopsStrategy___default.a
    }, {
      path: 'playtotype-offerings',
      component: __WEBPACK_IMPORTED_MODULE_7__components_WorkshopsPlaytotype___default.a
    }, {
      path: 'playtotype',
      component: __WEBPACK_IMPORTED_MODULE_8__components_WorkshopsExperiential___default.a
    }, {
      path: 'play',
      redirect: 'playtotype'
    }, {
      path: 'bespoke',
      redirect: 'playtotype'
    }, {
      path: 'christmas',
      name: 'Christmas',
      component: __WEBPACK_IMPORTED_MODULE_9__components_ChristmasWorkshops___default.a
    }, {
      path: 'c',
      name: 'Christmas Campaign',
      component: __WEBPACK_IMPORTED_MODULE_10__components_ChristmasCampaign___default.a
    }]
  }, { path: '*', redirect: '/' }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return { x: 0, y: 0 };
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach(function (to, from, next) {
  window.scrollTo(0, 0);
  next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(131)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(64),
  /* template */
  __webpack_require__(211),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 61 */,
/* 62 */,
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_waypoint__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_waypoint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_waypoint__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_resource__ = __webpack_require__(61);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_waypoint___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_resource__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',

  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_HatoPressFooter__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_HatoPressFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_HatoPressFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Newsletter__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Newsletter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Newsletter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_NavMain__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_NavMain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_NavMain__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    HatoPressFooter: __WEBPACK_IMPORTED_MODULE_0__components_HatoPressFooter___default.a,
    Newsletter: __WEBPACK_IMPORTED_MODULE_1__components_Newsletter___default.a,
    NavMain: __WEBPACK_IMPORTED_MODULE_2__components_NavMain___default.a
  }
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HeroVideo__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HeroVideo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_HeroVideo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Flickity__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Flickity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Flickity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);



var shopifyAccessToken = 'cd6c295cb0e4c351d45757ab4f18ec80';
var shopifyGraphQL = 'https://shop.hatopress.net/api/graphql';
var shopifyGraphQLQueryByHandle = function shopifyGraphQLQueryByHandle() {
  var handle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'workshopcarousel';

  return '\n    {\n      shop {\n        name\n        primaryDomain {\n          url\n          host\n          sslEnabled\n        }\n      }\n      collectionByHandle(handle: "workshopcarousel") {\n        id\n        products(first: 100) {\n          edges {\n            node {\n              id\n              title\n              handle\n              options {\n                name\n                values\n              }\n              images(first:3) {\n                edges {\n                  node {\n                    altText\n                    id\n                    originalSrc\n                    transformedSrc(maxWidth: 1600)\n                  }\n                }\n              }\n              variants(first: 1) {\n                edges {\n                  node {\n                    title\n                    selectedOptions {\n                      name\n                      value\n                    }\n                    image {\n                      src\n                    }\n                    price\n                    availableForSale\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  ';
};
var shopifyGraphQLConfig = {
  headers: {
    'X-Shopify-Storefront-Access-Token': shopifyAccessToken,
    'Content-Type': 'application/graphql'
  }
};




/* harmony default export */ __webpack_exports__["default"] = ({
  ready: function ready() {
    var self = this;
    window.addEventListener('resize', self.handleResize);
  },
  beforeDestroy: function beforeDestroy() {
    var self = this;
    window.addEventListener('resize', self.handleResize);
  },
  components: {
    HeroVideo: __WEBPACK_IMPORTED_MODULE_2__components_HeroVideo___default.a,
    Flickity: __WEBPACK_IMPORTED_MODULE_3__components_Flickity___default.a
  },
  created: function created() {
    this.runShopifyGraphQLRequest();
  },
  data: function data() {
    return {
      carousel: null,
      shop: null,
      workshops: null,
      shopify_collection_handle: 'workshopcarousel',
      flickityOptions: {
        initialIndex: 0,

        prevNextButtons: true,
        pageDots: false,
        wrapAround: false,
        setGallerySize: true,

        autoPlay: 3000
      }
    };
  },
  mounted: function mounted() {},

  methods: {
    runShopifyGraphQLRequest: function runShopifyGraphQLRequest() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$http.post(shopifyGraphQL, shopifyGraphQLQueryByHandle(_this.shopify_collection_handle), shopifyGraphQLConfig);

              case 2:
                res = _context.sent;

                _this.workshops = res.body.data.collectionByHandle.products.edges;
                _this.shop = res.body.data.shop;

                _this.workshops = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(_this.workshops, function (workshop) {
                  workshop.productTitle = _this.getShopifyProductTitle(workshop.node.title);
                  workshop.productDate = _this.getShopifyProductDate(workshop.node.title);
                  workshop.productMonth = _this.getShopifyProductMonth(workshop.node.title);
                  workshop.productTime = _this.getShopifyProductTime(workshop.node.title);
                  workshop.productPrice = _this.getShopifyProductPrice(workshop.node);
                  workshop.productAvailableForSale = _this.getShopifyProductAvailableForSale(workshop.node);
                  workshop.productUrl = _this.getShopifyProductURL(workshop.node.handle);
                  workshop.productImage = _this.getShopifyProductImage(workshop.node);

                  if (workshop.productTitle.indexOf('Booth') > 0) {
                    workshop.productTime = 'Selected dates in June and July';
                    workshop.productDate = 'Selected dates in June and July';
                  }

                  return workshop;
                });

                setTimeout(function () {
                  _this.$refs.flickity.initFlickity();

                  var flkty = _this.$refs.flickity.flickity;
                  if (flkty) {}
                }, 100);

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getShopifyProductURL: function getShopifyProductURL(productHandle) {
      return this.shop.primaryDomain.url + '/collections/workshops/products/' + productHandle;
    },
    getShopifyProductPrice: function getShopifyProductPrice(product) {
      return '\xA3' + product.variants.edges[0].node.price;
    },
    getShopifyProductImage: function getShopifyProductImage(product) {
      return product.images.edges[1].node;
    },
    getShopifyProductTags: function getShopifyProductTags(product) {
      return '' + product;
    },
    getShopifyProductAvailableForSale: function getShopifyProductAvailableForSale(product) {
      return '' + product.variants.edges[0].node.availableForSale;
    },
    getShopifyProductTitle: function getShopifyProductTitle(productFullTitle) {
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.split(productFullTitle, /:/)[0];
    },
    getShopifyProductDate: function getShopifyProductDate(productFullTitle) {
      var dateTime = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.split(productFullTitle, /:/)[1];
      var date = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.split(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.replace(dateTime, /(January|February|March|April|May|June|July|August|September|October|November|December)/, function (month) {
        return month + '---';
      }), '---')[0];
      return date;
    },
    getShopifyProductMonth: function getShopifyProductMonth(productFullTitle) {
      var dateTime = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.split(productFullTitle, /:/)[1];
      var month = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.split(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.replace(dateTime, /(January|February|March|April|May|June|July|August|September|October|November|December)/, function (month) {
        return '---' + month + '---';
      }), '---')[1];

      if (productFullTitle.indexOf('Booth') > 0) {}
      return month;
    },
    getShopifyProductTime: function getShopifyProductTime(productFullTitle) {
      var dateTime = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.split(productFullTitle, /:/)[1];
      var time = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.split(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.replace(dateTime, /(January|February|March|April|May|June|July|August|September|October|November|December)/, function (month) {
        return month + '---';
      }), '---')[1];
      time = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.trim(time, ',');
      time = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.trim(time, ' ');
      return time;
    },

    flkty_staticClick: function flkty_staticClick(event, pointer, cellElement, cellIndex) {
      var self = this;
      var flkty = self.$refs.flickity.flickity;
      if (cellIndex === flkty.selectedIndex) {
        if (self.carousel[cellIndex] && self.carousel[cellIndex].url) {} else {
          return;
        }
      } else if (cellIndex >= flkty.selectedIndex) {
        self.$refs.flickity.next();
      } else {
        self.$refs.flickity.previous();
      }
    }
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      cardImage: __webpack_require__(31)
    };
  }
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Nav1__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Nav1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Nav1__);





/* harmony default export */ __webpack_exports__["default"] = ({
  ready: function ready() {
    var self = this;
    window.addEventListener('resize', self.handleResize);
  },
  beforeDestroy: function beforeDestroy() {
    var self = this;
    window.addEventListener('resize', self.handleResize);
  },
  components: {
    Nav1: __WEBPACK_IMPORTED_MODULE_0__components_Nav1___default.a
  },
  data: function data() {
    return {
      carousel: null,
      flickityOptions: {
        initialIndex: 0,

        prevNextButtons: true,
        pageDots: false,
        wrapAround: false,
        setGallerySize: true
      }
    };
  },

  computed: {
    windowSize: function windowSize() {
      return window.innerWidth;
    }
  },
  mounted: function mounted() {
    this.fetchData();
  },

  methods: {
    scrollTo: function scrollTo(elementID) {
      if (document.getElementById(elementID)) {
        document.getElementById(elementID).scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    },
    fetchData: function fetchData() {},

    isMobile: function isMobile() {
      var self = this;
      return self.windowSize < 640;
    }
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Nav1__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Nav1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Nav1__);





/* harmony default export */ __webpack_exports__["default"] = ({
  ready: function ready() {
    var self = this;
    window.addEventListener('resize', self.handleResize);
  },
  beforeDestroy: function beforeDestroy() {
    var self = this;
    window.addEventListener('resize', self.handleResize);
  },
  components: {
    Nav1: __WEBPACK_IMPORTED_MODULE_0__components_Nav1___default.a
  },
  data: function data() {
    return {
      carousel: null,
      flickityOptions: {
        initialIndex: 0,

        prevNextButtons: true,
        pageDots: false,
        wrapAround: false,
        setGallerySize: true
      }
    };
  },

  computed: {
    windowSize: function windowSize() {
      return window.innerWidth;
    }
  },
  mounted: function mounted() {
    this.fetchData();
  },

  methods: {
    scrollTo: function scrollTo(elementID) {
      if (document.getElementById(elementID)) {
        document.getElementById(elementID).scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    },
    fetchData: function fetchData() {},

    isMobile: function isMobile() {
      var self = this;
      return self.windowSize < 640;
    }
  }
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_flickity__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_flickity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_flickity__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {
    this.flickity.destroy();
    this.flickity = null;
  },


  methods: {
    initFlickity: function initFlickity() {
      console.log('initFlickity!');
      this.flickity = new __WEBPACK_IMPORTED_MODULE_0_flickity___default.a(this.$el, this.options);
    },
    next: function next(isWrapped, isInstant) {
      this.flickity.next(isWrapped, isInstant);
    },
    previous: function previous(isWrapped, isInstant) {
      this.flickity.previous(isWrapped, isInstant);
    },
    select: function select(index, isWrapped, isInstant) {
      this.flickity.select(index, isWrapped, isInstant);
    },
    selectCell: function selectCell(value, isWrapped, isInstant) {
      this.flickity.selectCell(value, isWrapped, isInstant);
    },
    resize: function resize() {
      this.flickity.resize();
    },
    reposition: function reposition() {
      this.flickity.reposition();
    },
    prepend: function prepend(elements) {
      this.flickity.prepend(elements);
    },
    append: function append(elements) {
      this.flickity.append(elements);
    },
    insert: function insert(elements, index) {
      this.flickity.insert(elements, index);
    },
    remove: function remove(elements) {
      this.flickity.remove(elements);
    },
    playPlayer: function playPlayer() {
      this.flickity.playPlayer();
    },
    stopPlayer: function stopPlayer() {
      this.flickity.stopPlayer();
    },
    pausePlayer: function pausePlayer() {
      this.flickity.pausePlayer();
    },
    unpausePlayer: function unpausePlayer() {
      this.flickity.unpausePlayer();
    },
    destroy: function destroy() {
      this.flickity.destroy();
    },
    reloadCells: function reloadCells() {
      this.flickity.reloadCells();
    },
    getCellElements: function getCellElements() {
      this.flickity.getCellElements();
    },
    data: function data() {
      return __WEBPACK_IMPORTED_MODULE_0_flickity___default.a.data(this.$el);
    },
    on: function on(eventName, listener) {
      this.flickity.on(eventName, listener);
    },
    off: function off(eventName, listener) {
      this.flickity.off(eventName, listener);
    },
    once: function once(eventName, listener) {
      this.flickity.once(eventName, listener);
    }
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      cardImage: __webpack_require__(31)
    };
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'bye'
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    image: {
      type: String,
      default: function _default() {
        return '';
      }
    }
  },
  data: function data() {
    return {
      windowWidth: window.innerWidth
    };
  },

  methods: {
    handleWindowResize: function handleWindowResize(event) {
      var self = this;
      self.windowWidth = event.currentTarget.innerWidth;
    },
    isMobile: function isMobile() {
      var self = this;
      return self.windowWidth < 640;
    }
  },
  beforeDestroy: function beforeDestroy() {
    var self = this;
    window.removeEventListener('resize', self.handleWindowResize);
  },
  mounted: function mounted() {
    var self = this;
    window.addEventListener('resize', self.handleWindowResize);
  }
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      type: String,
      default: '50%'
    },
    fill: {
      type: String,
      default: 'contain'
    }
  },
  data: function data() {
    return {
      windowWidth: window.innerWidth,
      video: {
        source: 'https://player.vimeo.com/video/222339794?api=1&background=1&mute=1&loop=1',
        poster: __webpack_require__(175)
      }
    };
  },

  methods: {
    handleWindowResize: function handleWindowResize(event) {
      var self = this;
      self.windowWidth = event.currentTarget.innerWidth;
    },
    isMobile: function isMobile() {
      var self = this;
      return self.windowWidth < 1024;
    }
  },
  beforeDestroy: function beforeDestroy() {
    var self = this;
    window.removeEventListener('resize', self.handleWindowResize);
  },
  mounted: function mounted() {
    var self = this;
    window.addEventListener('resize', self.handleWindowResize);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {
      hero: {
        image: 'https://cdn.shopify.com/s/files/1/0884/7454/products/Hato-Printing-Workshop-documentation-18_6a73ac37-37d1-4884-a236-3ac48ed6a524.jpg?v=1491209873',

        reel1: '222338373',
        reel2: '222339794'
      }
    };
  },

  computed: {
    windowSize: function windowSize() {
      return window.innerWidth;
    }
  },
  methods: {
    handleResize: function handleResize(event) {
      console.log('handleResize:', event);
    }
  }
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      instagrams: []
    };
  },
  created: function created() {
    this.fetchData();
  },

  methods: {
    fetchData: function fetchData() {
      this.instagrams = [{
        'title': '',
        'thumbnail': '/static/Hato-Press-instagram1.jpg',
        'url': 'https://www.instagram.com/p/Bmp6Wu_j-iI/?tagged=hatopress'
      }, {
        'title': '',
        'thumbnail': '/static/Hato-Press-instagram2.jpg',
        'url': 'https://www.instagram.com/p/BSMJD-EB4wv/?tagged=learnwithhato'
      }, {
        'title': '',
        'thumbnail': '/static/Hato-Press-instagram3.jpg',
        'url': 'https://www.instagram.com/p/Boa_H7Tjll_/?tagged=hatopress'
      }, {
        'title': '',
        'thumbnail': '/static/Hato-Press-instagram4.jpg',
        'url': 'https://www.instagram.com/p/BoB61rhBUs-/?tagged=hatopress'
      }];
    }
  }
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      showNav1: true,
      urlSuffix: '',
      windowWidth: window.innerWidth
    };
  },

  props: {
    bg: {
      type: String,
      default: 'hsl(158, 90%, 66%)'
    }
  },
  methods: {
    handleWindowResize: function handleWindowResize(event) {
      var self = this;
      self.windowWidth = event.currentTarget.innerWidth;
    },
    isMobile: function isMobile() {
      var self = this;
      return self.windowWidth < 1024;
    }
  },
  beforeDestroy: function beforeDestroy() {
    var self = this;
    window.removeEventListener('resize', self.handleWindowResize);
  },
  mounted: function mounted() {
    var self = this;
    window.addEventListener('resize', self.handleWindowResize);
  }
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      showPopup: false,
      headerExpanded: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (this.$route.path !== '/christmas') {
      setTimeout(function () {
        _this.showPopup = true;
      }, 1500);
    } else {
      if (this.$route.hash === '#places') {
        setTimeout(function () {
          document.getElementById('places').scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }, 500);
      }
    }
  }
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      cardImage: __webpack_require__(31)
    };
  }
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__ = __webpack_require__(165);




/* harmony default export */ __webpack_exports__["default"] = ({
  beforeDestroy: function beforeDestroy() {},
  mounted: function mounted() {
    this.animate();
  },
  data: function data() {
    return {
      currentStyle: 1
    };
  },

  methods: {
    animate: function animate() {
      console.log('animate');
      __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["a" /* TweenMax */].fromTo('path', 2, {
        'stroke-dashoffset': 0
      }, {
        'stroke-dashoffset': 90,
        repeat: -1,
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["b" /* Power0 */].easeNone
      });

      this.yo();
    },
    yo: function yo() {
      this.shuffle_style();
      this.path_bounce();
    },
    path_bounce: function path_bounce() {
      __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["a" /* TweenMax */].fromTo('#play path', 2, {
        'stroke-width': 10
      }, {
        'stroke-width': 50 + Math.random() * 50,
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["c" /* Elastic */].easeOut.config(1.5, 0.2)
      });
    },
    shuffle_style: function shuffle_style() {
      var stroke = Math.random() * 70 + 10;
      var gap = 90 - stroke;
      var style0 = {
        'stroke-width': 20,

        'stroke-dasharray': gap + ' ' + stroke,
        'stroke-linecap': 'square',
        'stroke-linejoin': 'square'
      };
      var style1 = {
        'stroke-width': 20,

        'stroke-dasharray': stroke + ' ' + gap,
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round'
      };
      var style2 = {
        'stroke-width': 20,

        'stroke-dasharray': stroke / 3 + ' ' + gap / 3 + ' ' + stroke / 3 + ' ' + gap / 3 + ' ' + stroke / 3 + ' ' + gap / 3,
        'stroke-linecap': 'butt',
        'stroke-linejoin': 'miter'
      };
      switch (this.currentStyle) {
        case 0:
          __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["a" /* TweenMax */].set('#play path', style0);
          this.currentStyle = 1;
          break;
        case 1:
          __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["a" /* TweenMax */].set('#play path', style1);
          this.currentStyle = 2;
          break;
        case 2:
          __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["a" /* TweenMax */].set('#play path', style2);
          this.currentStyle = 0;
          break;
      }
    }
  }
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);



var shopifyAccessToken = 'cd6c295cb0e4c351d45757ab4f18ec80';
var shopifyGraphQL = 'https://shop.hatopress.net/api/graphql';
var shopifyGraphQLQueryByHandle = function shopifyGraphQLQueryByHandle() {
  var handle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'workshops';

  return '\n    {\n      shop {\n        name\n        primaryDomain {\n          url\n          host\n          sslEnabled\n        }\n      }\n      collectionByHandle(handle: "workshops") {\n        id\n        products(first: 100) {\n          edges {\n            node {\n              id\n              title\n              handle\n              options {\n                name\n                values\n              }\n              variants(first: 1) {\n                edges {\n                  node {\n                    title\n                    selectedOptions {\n                      name\n                      value\n                    }\n                    image {\n                      src\n                    }\n                    price\n                    availableForSale\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  ';
};
var shopifyGraphQLConfig = {
  headers: {
    'X-Shopify-Storefront-Access-Token': shopifyAccessToken,
    'Content-Type': 'application/graphql'
  }
};




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      workshopTypeFilter: '',
      workshopMonthFilter: '',
      workshops: null,
      months: null,
      shop: '',

      shopify_collection_handle: 'workshops',
      workshopFilteringInProgress: false,
      workshopFilterActive: true
    };
  },
  created: function created() {
    var _this = this;

    this.runShopifyGraphQLRequest();
    this.debounceShowFilters = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function () {
      _this.showFilters();
    }, 500);
  },

  watch: {
    workshopTypeFilter: function workshopTypeFilter(oldVal, newVal) {
      this.hideFilters();
    },
    workshopMonthFilter: function workshopMonthFilter(oldVal, newVal) {
      this.hideFilters();
    }
  },
  computed: {
    computedWorkshops: function computedWorkshops() {
      var _this2 = this;

      var self = this;
      if (!self.workshops) return null;

      return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(self.workshops, function (ws) {
        if (_this2.workshopMonthFilter && _this2.workshopTypeFilter) {
          return ws.productMonth === _this2.workshopMonthFilter && ws.customType === _this2.workshopTypeFilter;
        }
        if (_this2.workshopMonthFilter) {
          return ws.productMonth === _this2.workshopMonthFilter;
        }
        if (_this2.workshopTypeFilter) {
          return ws.customType === _this2.workshopTypeFilter;
        }
        return true;
      });
    },
    monthsOfWorkshops: function monthsOfWorkshops() {
      var self = this;
      if (!self.workshops) return null;
      var months = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniq(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(self.workshops, function (ws) {
        return ws.productMonth;
      }));
      months = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(months, function (month) {
        return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.indexOf(['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'], __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toLower(month));
      });
      return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(months, function (m) {
        if (m) {
          return true;
        }
        return false;
      });
    },
    typesOfWorkshops: function typesOfWorkshops() {
      var self = this;
      if (!self.workshops) return null;
      var types = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniq(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(self.workshops, function (ws) {
        return ws.customType;
      }));
      return types;
    }
  },
  methods: {
    hideFilters: function hideFilters() {
      this.workshopFilteringInProgress = true;
      this.debounceShowFilters();
    },
    showFilters: function showFilters() {
      this.workshopFilteringInProgress = false;
      var top = this.$refs.timetable.offsetTop - 100;

      window.scrollTo({
        top: top,
        behavior: 'smooth'
      });
    },
    runShopifyGraphQLRequest: function runShopifyGraphQLRequest() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this3.$http.post(shopifyGraphQL, shopifyGraphQLQueryByHandle(_this3.shopify_collection_handle), shopifyGraphQLConfig);

              case 2:
                res = _context.sent;

                _this3.workshops = res.body.data.collectionByHandle.products.edges;
                _this3.shop = res.body.data.shop;

                _this3.workshops = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(_this3.workshops, function (workshop) {
                  workshop.productTitle = _this3.getShopifyProductTitle(workshop.node.title);
                  workshop.productDate = _this3.getShopifyProductDate(workshop.node.title);
                  workshop.productMonth = _this3.getShopifyProductMonth(workshop.node.title);
                  workshop.productTime = _this3.getShopifyProductTime(workshop.node.title);
                  workshop.productPrice = _this3.getShopifyProductPrice(workshop.node);
                  workshop.productAvailableForSale = _this3.getShopifyProductAvailableForSale(workshop.node);
                  workshop.productUrl = _this3.getShopifyProductURL(workshop.node.handle);
                  workshop.customType = _this3.getFilterTypeName(workshop.productTitle);

                  if (workshop.productTitle.indexOf('Booth') > 0) {
                    workshop.productTime = 'Selected dates in June and July';
                  }

                  if (workshop.productTitle.indexOf('Publishing') > 0) {
                    workshop.productDate = _this3.getShopifyProductDate_Publishing(workshop.node.title);
                    workshop.productTime = '';
                  }

                  return workshop;
                });

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    getShopifyProductURL: function getShopifyProductURL(productHandle) {
      return this.shop.primaryDomain.url + '/collections/' + this.shopify_collection_handle + '/products/' + productHandle;
    },
    getShopifyProductPrice: function getShopifyProductPrice(product) {
      return '\xA3' + product.variants.edges[0].node.price;
    },
    getShopifyProductTags: function getShopifyProductTags(product) {
      return '' + product;
    },
    getShopifyProductAvailableForSale: function getShopifyProductAvailableForSale(product) {
      return '' + product.variants.edges[0].node.availableForSale;
    },
    getShopifyProductTitle: function getShopifyProductTitle(productFullTitle) {
      return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.split(productFullTitle, /:/)[0];
    },
    getShopifyProductDate_Publishing: function getShopifyProductDate_Publishing(productFullTitle) {
      var dateTime = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.split(productFullTitle, /:/)[1];

      return dateTime;
    },
    getShopifyProductDate: function getShopifyProductDate(productFullTitle) {
      var dateTime = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.split(productFullTitle, /:/)[1];
      var date = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.split(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.replace(dateTime, /(January|February|March|April|May|June|July|August|September|October|November|December)/, function (month) {
        return month + '---';
      }), '---')[0];
      return date;
    },
    getShopifyProductMonth: function getShopifyProductMonth(productFullTitle) {
      var dateTime = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.split(productFullTitle, /:/)[1];
      var month = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.split(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.replace(dateTime, /(January|February|March|April|May|June|July|August|September|October|November|December)/, function (month) {
        return '---' + month + '---';
      }), '---')[1];

      if (productFullTitle.indexOf('Booth') > 0) {}
      return month;
    },
    getShopifyProductTime: function getShopifyProductTime(productFullTitle) {
      var dateTime = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.split(productFullTitle, /:/)[1];
      var time = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.split(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.replace(dateTime, /(January|February|March|April|May|June|July|August|September|October|November|December)/, function (month) {
        return month + '---';
      }), '---')[1];
      time = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.trim(time, ',');
      time = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.trim(time, ' ');
      return time;
    },
    workshopMonthMatch: function workshopMonthMatch(workshop) {
      return this.workshopMonthFilter ? workshop.productMonth === this.workshopMonthFilter : true;
    },
    workshopTypeMatch: function workshopTypeMatch(workshop) {
      return this.workshopTypeFilter ? workshop.productTitle === this.workshopTypeFilter : true;
    },
    getFilterTypeName: function getFilterTypeName(productTitle) {
      if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toLower(productTitle), 'two-colour')) {
        return 'Two-colour Risograph';
      } else if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toLower(productTitle), 'fanzine')) {
        return 'Self-Publishing';
      } else if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toLower(productTitle), 'clay')) {
        return 'Clay Club';
      } else if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toLower(productTitle), 'kintsugi')) {
        return 'Kintsugi';
      } else if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toLower(productTitle), 'booth')) {
        return 'Drawing';
      } else if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toLower(productTitle), 'publishing')) {
        return 'Self-Publishing';
      } else if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toLower(productTitle), 'dye')) {
        return 'Dyeing';
      } else if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toLower(productTitle), 'kana')) {
        return 'Ceramics';
      } else {
        return 'Exclusive';
      }
    }
  }
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Nav1__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Nav1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Nav1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Flickity__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Flickity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Flickity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hero__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hero___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Hero__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Newsletter__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Newsletter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Newsletter__);







/* harmony default export */ __webpack_exports__["default"] = ({
  ready: function ready() {
    var self = this;
    window.addEventListener('resize', self.handleResize);
  },
  beforeDestroy: function beforeDestroy() {
    var self = this;
    window.addEventListener('resize', self.handleResize);
  },
  components: {
    Nav1: __WEBPACK_IMPORTED_MODULE_0__components_Nav1___default.a,
    Flickity: __WEBPACK_IMPORTED_MODULE_1__components_Flickity___default.a,
    Hero: __WEBPACK_IMPORTED_MODULE_2__components_Hero___default.a,
    Newsletter: __WEBPACK_IMPORTED_MODULE_3__components_Newsletter___default.a
  },
  data: function data() {
    return {
      hero: __webpack_require__(55),
      products: [{
        title: 'Make a zine',
        text: 'Flex your creative muscles and learn how to build and print your own zine.',
        key: ['Learn about riso printing and basic bookbinding skills', 'Leave with a set number of prints and a zine containing prints from other participants', 'Design a cover with participants from your group', 'Complimentary food and drinks are included but optional']
      }, {
        title: 'Riso party',
        text: 'We’ll begin with an introduction and a test exercise on riso-printing. Then it’s your turn to experiment and artwork using a range of materials.',
        key: ['Learn about riso printing and see the live printing action', 'Choose to print your designs as A3/A4 prints or on a set of postcards, cards, wrapping paper', 'Complimentary food and drinks are included but optional']
      }, {
        title: 'Hato Experience Day',
        text: 'Explore the thriving community around our studio and create a riso-print as a token from your day out.',
        key: ['We’ll meet at our studio then it’s off to getting your artisanal caffeine fix from one of our local coffee shops', 'Explore Columbia Road Flower Market, only a stone\'s throw away from Hato Press', 'Take your botanical purchases from the market or use our materials to create your own rubbings ', 'Learn about pattern-making and risograph printing', 'Transform your artwork into a riso-print and take home 10 copies', 'Complimentary food and drinks are included but optional']
      }],
      carousel: [{
        text: 'Bao',
        image: 'https://scontent-lhr3-1.cdninstagram.com/t51.2885-15/e35/17438461_174435699740537_1721658144775471104_n.jpg'
      }],
      flickityOptions: {
        initialIndex: 0,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: false,
        setGallerySize: true,
        autoPlay: 3000
      }
    };
  },

  methods: {}
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Nav1__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Nav1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Nav1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Flickity__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Flickity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Flickity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hero__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hero___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Hero__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Mailchimp__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Mailchimp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Mailchimp__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Nav1: __WEBPACK_IMPORTED_MODULE_0__components_Nav1___default.a,
    Flickity: __WEBPACK_IMPORTED_MODULE_1__components_Flickity___default.a,
    Hero: __WEBPACK_IMPORTED_MODULE_2__components_Hero___default.a,
    Mailchimp: __WEBPACK_IMPORTED_MODULE_3__components_Mailchimp___default.a
  },
  data: function data() {
    return {
      hero: __webpack_require__(186),
      carousel: [{
        text: 'Bao',
        image: 'https://scontent-lhr3-1.cdninstagram.com/t51.2885-15/e35/17438461_174435699740537_1721658144775471104_n.jpg'
      }],
      flickityOptions: {
        initialIndex: 0,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: false,
        setGallerySize: true,
        autoPlay: 3000
      }
    };
  },

  methods: {}
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Nav1__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Nav1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Nav1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Flickity__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Flickity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Flickity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hero__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hero___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Hero__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Newsletter__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Newsletter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Newsletter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Play__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Play___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Play__);








/* harmony default export */ __webpack_exports__["default"] = ({
  ready: function ready() {
    var self = this;
    window.addEventListener('resize', self.handleResize);
  },
  beforeDestroy: function beforeDestroy() {
    var self = this;
    window.addEventListener('resize', self.handleResize);
  },
  components: {
    Nav1: __WEBPACK_IMPORTED_MODULE_0__components_Nav1___default.a,
    Flickity: __WEBPACK_IMPORTED_MODULE_1__components_Flickity___default.a,
    Hero: __WEBPACK_IMPORTED_MODULE_2__components_Hero___default.a,
    Newsletter: __WEBPACK_IMPORTED_MODULE_3__components_Newsletter___default.a,
    Play: __WEBPACK_IMPORTED_MODULE_4__components_Play___default.a
  },
  mounted: function mounted() {
    this.$refs.flickity.initFlickity();
  },
  data: function data() {
    return {
      onpress: __webpack_require__(177),
      diagram: __webpack_require__(176),
      carousel: [{
        text: 'Bao',
        image: 'https://scontent-lhr3-1.cdninstagram.com/t51.2885-15/e35/17438461_174435699740537_1721658144775471104_n.jpg'
      }],
      flickityOptions: {
        contain: true,
        initialIndex: 0,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: false,
        setGallerySize: true,
        autoPlay: false
      },
      expand: false
    };
  },

  methods: {}
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Nav1__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Nav1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Nav1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Flickity__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Flickity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Flickity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hero__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hero___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Hero__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Newsletter__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Newsletter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Newsletter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Play__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Play___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Play__);








/* harmony default export */ __webpack_exports__["default"] = ({
  ready: function ready() {
    var self = this;
    window.addEventListener('resize', self.handleResize);
  },
  beforeDestroy: function beforeDestroy() {
    var self = this;
    window.addEventListener('resize', self.handleResize);
  },
  components: {
    Nav1: __WEBPACK_IMPORTED_MODULE_0__components_Nav1___default.a,
    Flickity: __WEBPACK_IMPORTED_MODULE_1__components_Flickity___default.a,
    Hero: __WEBPACK_IMPORTED_MODULE_2__components_Hero___default.a,
    Newsletter: __WEBPACK_IMPORTED_MODULE_3__components_Newsletter___default.a,
    Play: __WEBPACK_IMPORTED_MODULE_4__components_Play___default.a
  },
  mounted: function mounted() {
    this.$refs.flickity.initFlickity();
  },
  data: function data() {
    return {
      hero: __webpack_require__(55),
      carousel: [{
        text: 'Bao',
        image: 'https://scontent-lhr3-1.cdninstagram.com/t51.2885-15/e35/17438461_174435699740537_1721658144775471104_n.jpg'
      }],
      flickityOptions: {
        initialIndex: 0,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: false,
        setGallerySize: true,
        autoPlay: 3000
      }
    };
  },

  methods: {}
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Nav1__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Nav1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Nav1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeroVideo__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeroVideo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_HeroVideo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Flickity__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Flickity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Flickity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Timetable__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Timetable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Timetable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Carousel__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Instagrams__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Instagrams___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Instagrams__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Christmas__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Christmas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Christmas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Gift__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Gift___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Gift__);












/* harmony default export */ __webpack_exports__["default"] = ({
  ready: function ready() {
    var self = this;
    window.addEventListener('resize', self.handleResize);
  },
  beforeDestroy: function beforeDestroy() {
    var self = this;
    window.addEventListener('resize', self.handleResize);
  },
  components: {
    Nav1: __WEBPACK_IMPORTED_MODULE_0__components_Nav1___default.a,
    HeroVideo: __WEBPACK_IMPORTED_MODULE_1__components_HeroVideo___default.a,
    Flickity: __WEBPACK_IMPORTED_MODULE_2__components_Flickity___default.a,
    Timetable: __WEBPACK_IMPORTED_MODULE_3__components_Timetable___default.a,
    Instagrams: __WEBPACK_IMPORTED_MODULE_5__components_Instagrams___default.a,
    Gift: __WEBPACK_IMPORTED_MODULE_7__components_Gift___default.a,
    Christmas: __WEBPACK_IMPORTED_MODULE_6__components_Christmas___default.a,
    Carousel: __WEBPACK_IMPORTED_MODULE_4__components_Carousel___default.a
  },
  data: function data() {
    return {
      scrollEventAdded: false,
      windowPageYOffset: 0,
      carousel: null,
      flickityOptions: {
        initialIndex: 0,

        prevNextButtons: true,
        pageDots: false,
        wrapAround: false,
        setGallerySize: true,

        autoPlay: 3000
      }
    };
  },

  computed: {
    windowSize: function windowSize() {
      return window.innerWidth;
    }
  },
  mounted: function mounted() {},

  methods: {
    addScrollEvent: function addScrollEvent() {
      var _this = this;

      if (this.scrollEventAdded) return;
      this.scrollEventAdded = true;
      window.addEventListener('scroll', function (e) {
        console.log();
        _this.windowPageYOffset = window.pageYOffset;
      });
    },

    handleResize: function handleResize(event) {
      console.log('handleResize:', event);
    },

    isMobile: function isMobile() {
      var self = this;
      return self.windowSize < 640;
    },

    getQuery: function getQuery() {
      var self = this;
      var query = '?';

      query += '_=_';

      query += self.$route.query.utm_campaign ? '&utm_campaign=' + self.$route.query.utm_campaign : '';
      query += self.$route.query.utm_content ? '&utm_content=' + self.$route.query.utm_content + '-carouselaction' : '&utm_content=carouselaction';
      query += self.$route.query.utm_medium ? '&utm_medium=' + self.$route.query.utm_medium : '';
      query += self.$route.query.utm_source ? '&utm_source=' + self.$route.query.utm_source : '';
      query += self.$route.query.utm_term ? '&utm_term=' + self.$route.query.utm_term : '';
      query += self.$route.query.mc_cid ? '&mc_cid=' + self.$route.query.mc_cid : '';
      query += self.$route.query.mc_eid ? '&mc_eid=' + self.$route.query.mc_eid : '';

      return query;
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Nav1__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Nav1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Nav1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Hero__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Hero___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Hero__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Flickity__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Flickity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Flickity__);







/* harmony default export */ __webpack_exports__["default"] = ({
  ready: function ready() {
    var self = this;
    window.addEventListener('resize', self.handleResize);
  },
  beforeDestroy: function beforeDestroy() {
    var self = this;
    window.addEventListener('resize', self.handleResize);
  },
  components: {
    Nav1: __WEBPACK_IMPORTED_MODULE_0__components_Nav1___default.a,
    Flickity: __WEBPACK_IMPORTED_MODULE_2__components_Flickity___default.a,

    Hero: __WEBPACK_IMPORTED_MODULE_1__components_Hero___default.a
  },
  data: function data() {
    return {
      hero: __webpack_require__(56),
      carousel: [{
        image: __webpack_require__(178),
        text: 'D&AD New Blood Academy'
      }, {
        image: __webpack_require__(56),
        text: 'Whitechapel Gallery'
      }, {
        image: __webpack_require__(184),
        text: 'It’s Nice That'
      }, {
        image: __webpack_require__(181),
        text: 'Royal Academy'
      }, {
        image: __webpack_require__(179),
        text: 'Jean Jullien book launch'
      }, {
        image: __webpack_require__(185),
        text: 'Liverpool Biennial'
      }, {
        image: __webpack_require__(182),
        text: 'The V&A Museum of Childhood'
      }, {
        image: __webpack_require__(183),
        text: 'Whitechapel Gallery'
      }, {
        image: __webpack_require__(180),
        text: 'Serpentine Galleries'
      }],
      flickityOptions: {
        initialIndex: 0,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: false,
        setGallerySize: true
      }
    };
  },
  mounted: function mounted() {
    var self = this;
    self.$refs.flickity.initFlickity();
    var flkty = self.$refs.flickity.flickity;
    if (flkty) {
      flkty.on('staticClick', self.flkty_staticClick);
    }
  },

  methods: {
    flkty_staticClick: function flkty_staticClick(event, pointer, cellElement, cellIndex) {
      var self = this;
      var flkty = self.$refs.flickity.flickity;
      if (cellIndex >= flkty.selectedIndex) {
        self.$refs.flickity.next();
      } else {
        self.$refs.flickity.previous();
      }
    },
    handleResize: function handleResize(event) {
      console.log('handleResize:', event);
    }
  }
});

/***/ }),
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 125 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 126 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 127 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 128 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 129 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 130 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 131 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 132 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 137 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 139 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 140 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 141 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 143 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 144 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 145 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 146 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 147 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/corporate-logo-blocks.0722de4.png";

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/strategy-logo-blocks-2.5aed118.png";

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hatopress-reel-viemo-poster-1.6d55edf.jpg";

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/HATO-Playtotype-Diagram.853b6d8.png";

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Hato-Selfridges-ON-PRESS-3600-6R9A3308.eb558f8.jpg";

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hatopress-dandad.c5e8081.jpg";

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hatopress-jj-underdogs-painting-1.67f1271.jpg";

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hatopress-workshops-archive-1.44e436a.jpg";

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hatopress-workshops-archive-10.ce150dd.jpg";

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hatopress-workshops-archive-4.807c2c0.jpg";

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hatopress-workshops-archive-6.60c8e45.jpg";

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hatopress-workshops-archive-9.d61f791.jpg";

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/liverpool.dc1531f.jpg";

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/whitechapel-cropped-1.0dcb00b.jpg";

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(142)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(222),
  /* scopeId */
  "data-v-7ec9521f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(143)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(66),
  /* template */
  __webpack_require__(223),
  /* scopeId */
  "data-v-a417685a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(145)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(67),
  /* template */
  __webpack_require__(225),
  /* scopeId */
  "data-v-b203a3fa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(126)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(206),
  /* scopeId */
  "data-v-1cf93569",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(129)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(70),
  /* template */
  __webpack_require__(209),
  /* scopeId */
  "data-v-35e81d6f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(132)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(212),
  /* scopeId */
  "data-v-42c37b7b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(127)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(207),
  /* scopeId */
  "data-v-33658cc4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(144)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(75),
  /* template */
  __webpack_require__(224),
  /* scopeId */
  "data-v-a6df8d00",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(146)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(76),
  /* template */
  __webpack_require__(226),
  /* scopeId */
  "data-v-f02a097e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(147)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(78),
  /* template */
  __webpack_require__(227),
  /* scopeId */
  "data-v-fac6c1e6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(140)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(81),
  /* template */
  __webpack_require__(220),
  /* scopeId */
  "data-v-7d65b1f2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(135)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(82),
  /* template */
  __webpack_require__(215),
  /* scopeId */
  "data-v-523c29fc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(128)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(208),
  /* scopeId */
  "data-v-346ba20b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(139)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(84),
  /* template */
  __webpack_require__(219),
  /* scopeId */
  "data-v-75cdf025",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(125)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(85),
  /* template */
  __webpack_require__(205),
  /* scopeId */
  "data-v-0ce66634",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(124)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(204),
  /* scopeId */
  "data-v-05ac0bef",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(136)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(87),
  /* template */
  __webpack_require__(216),
  /* scopeId */
  "data-v-5e99f430",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 204 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workshops-regular",
    class: {
      'scrolled': _vm.windowPageYOffset > 0
    }
  }, [_c('nav-1'), _vm._v(" "), _c('carousel'), _vm._v(" "), _c('timetable'), _vm._v(" "), _c('instagrams'), _vm._v(" "), _c('gift'), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "action content-text"
  }, [_c('h2', {}, [_vm._v("\n      Get in touch to learn more about our bespoke workshops, or any general enquiries on workshops.\n    ")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "mailto:learn@hatopress.net"
    }
  }, [_vm._v("learn@hatopress.net")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "tel:+44-207-729-5585"
    }
  }, [_vm._v("+44 (0)207 729 5585")])])
}]}

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workshops-bespoke"
  }, [_c('nav-1'), _vm._v(" "), _c('play'), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "carousel-wrapper testimonials"
  }, [_c('h2', [_vm._v("What our clients say")]), _vm._v(" "), _c('flickity', {
    ref: "flickity",
    staticClass: "carousel",
    attrs: {
      "options": _vm.flickityOptions
    }
  }, [_c('div', {
    staticClass: "carousel-cell quote"
  }, [_c('h3', [_vm._v("“Our creative team loved the chance to roll up our sleeves and learn risoprinting from one of the finest studios in London. The session was well run. Hats off to Hato.”")]), _vm._v(" "), _c('p', [_vm._v("Shirley, Senior Copywriter, Virgin Media")])]), _vm._v(" "), _c('div', {
    staticClass: "carousel-cell quote"
  }, [_c('h3', [_vm._v("“The two colour workshop was perfect for our group to experiment and get creative. We learnt loads and would recommend to anyone!”")]), _vm._v(" "), _c('p', [_vm._v("Emma, Graphic Designer, Boden")])]), _vm._v(" "), _c('div', {
    staticClass: "carousel-cell quote xl"
  }, [_c('h3', [_vm._v("“The Hato Christmas Card workshop was the perfect activity for the team to get out the office and learn and do something new together. The instructors were amazing, offering motivation and tips throughout. We came away with a new appreciation for the risograph print process, along with some fantastic printed cards (some showing more creative skill than others!).”")]), _vm._v(" "), _c('p', [_vm._v("Helen Scibilia, Project Manager, YCN")])]), _vm._v(" "), _c('div', {
    staticClass: "carousel-cell quote"
  }, [_c('h3', [_vm._v("“We have a great Riso printing session at Hato, really learnt a lot and was great fun. Was a great way to work on something different whilst enjoying a beer ;-).”")]), _vm._v(" "), _c('p', [_vm._v("Alex Prior, Head of Graphic Design at The Hoxton")])])])], 1), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-text"
  }, [_c('h1', [_vm._v("\n      Play as a Method of Working\n      "), _c('small', [_vm._v("Playtotyping")])]), _vm._v(" "), _c('h4', {
    staticClass: "size__content__default pos__content__center"
  }, [_vm._v("\n      Playtotyping is our approach and method of working. It engages and spurs people to play in order to solve a problem or answer a brief or quite simply to have fun and be creative.\n    ")]), _vm._v(" "), _c('h4', {
    staticClass: "size__content__default pos__content__center"
  }, [_vm._v("\n      We use design, craft and technology to give people the tools to connect with their inherent creativity, to express their ideas and collaborate with each other.\n    ")]), _vm._v(" "), _c('h4', {
    staticClass: "size__content__default pos__content__center"
  }, [_vm._v("\n      The overall aim of playtotyping is to move and inspire communities, clients and individuals to innovate and create new ways of thinking and doing through the art of play.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-text outcomes"
  }, [_c('h4', {
    staticClass: "size__content__default pos__content__center"
  }, [_vm._v("\n      At HATO we believe that being playful and creative are part of the everyday. We use this ethos throughout our own practice. Through our public and private workshops programme we are able to engage others to do the same.\n    ")]), _vm._v(" "), _c('h4', {
    staticClass: "size__content__default pos__content__center"
  }, [_vm._v("\n      Our experiential workshops are built around teams and groups wanting to explore play and creativity in a fun and inspiring way. Either hosted at our East London studio or at your own space be it your office/studio or temporary space, our team of workshop leaders and printers are able to devise tailored Riso printing and image making sessions that inspire new perspectives amongst teams and ensure a fun and engaging social event.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-text outcomes-visual"
  }, [_c('h2', [_vm._v("Outcomes")]), _vm._v(" "), _c('div', {
    staticClass: "outcomes-boxes"
  }, [_c('div', {
    staticClass: "outcomes-box"
  }, [_vm._v("\n        Creative Thinking\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "outcomes-box"
  }, [_vm._v("\n        Wellbeing\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "outcomes-box"
  }, [_vm._v("\n        Innovation\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "outcomes-box"
  }, [_vm._v("\n        Team Building\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "outcomes-box"
  }, [_vm._v("\n        Re-Engage"), _c('br'), _vm._v("Kinesthetic\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "outcomes-box"
  }, [_vm._v("\n        Increase Visual"), _c('br'), _vm._v("Learning methods\n      ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-text cta"
  }, [_c('div', {
    staticClass: "action"
  }, [_c('h3', [_vm._v("Let us customise your next workshop experience.")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:bespoke@hatopress.net?subject=Bespoke Workshops"
    }
  }, [_vm._v("bespoke@hatopress.net")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:+44-207-729-5585"
    }
  }, [_vm._v("+44 (0)207 729 5585")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-logos"
  }, [_c('img', {
    staticClass: "size__content__narrow",
    attrs: {
      "src": __webpack_require__(54),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-text cta"
  }, [_c('div', {
    staticClass: "action"
  }, [_c('h3', [_vm._v("Let's begin.")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:bespoke@hatopress.net?subject=Bespoke Workshops"
    }
  }, [_vm._v("bespoke@hatopress.net")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:+44-207-729-5585"
    }
  }, [_vm._v("+44 (0)207 729 5585")])])])
}]}

/***/ }),
/* 206 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workshops-regular"
  }, [_c('nav-1', {
    attrs: {
      "bg": 'hsl(38, 63%, 75%)'
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "workshops content-wrapper"
  }, [_c('div', {
    staticClass: "content-text"
  }, [_c('div', {
    staticClass: "two-columns vertical-centerd"
  }, [_c('div', {
    staticClass: "column mobile-order-1"
  }, [_c('h4', {
    staticClass: "gold"
  }, [_vm._v("Christmas Card Making Workshop")]), _vm._v(" "), _c('p', [_vm._v("We’re encouraging you to get personal this Yuletide with some creative card-making to send to your nearest and dearest. We’ll take you behind the scenes at our printing studio, packed with different paper stock, riso drums and colourful ink tubes. Then it’s time to experiment using a mixture of collage and mark-making techniques where you will create 20 creased A6 cards, printed in 2 colours on our risograph printers.")]), _vm._v(" "), _c('a', {
    staticClass: "gold-hover",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.scrollTo('prices')
      }
    }
  }, [_vm._v("View Options →")])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "two-columns vertical-centerd"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "column mobile-order-1"
  }, [_c('h4', {
    staticClass: "gold"
  }, [_vm._v("Wrapping Paper Workshop")]), _vm._v(" "), _c('p', [_vm._v("Rubbish at buying presents? Always seem to get it wrong? Well, we can’t help you there. What we can do, however, is to make that slightly average gift look utterly spectacular. All you need is good wrapping paper. Hato Press will teach you a lesson in pattern-making so that you can design and print your own bespoke wrap. 20 folded A2 sheets of beautifully printed riso that guarantees to make that pair of cotton socks seem unusually desirable.")]), _vm._v(" "), _c('a', {
    staticClass: "gold-hover",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.scrollTo('prices')
      }
    }
  }, [_vm._v("View Options →")])])])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "prices content-wrapper",
    attrs: {
      "id": "prices"
    }
  }, [_c('div', {
    staticClass: "content-text"
  }, [_c('div', {
    staticClass: "two-columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h4', {
    staticClass: "gold"
  }, [_vm._v("Prices Per Party")]), _vm._v(" "), _c('p', [_vm._v("Chose from either Christmas Card Making or Wrapping Paper Workshops.")]), _vm._v(" "), _c('h5', {
    staticClass: "gold"
  }, [_vm._v("Parties at Hato Press")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('h5', {
    staticClass: "gold"
  }, [_vm._v("Hato Press comes to you")]), _vm._v(" "), _c('p', [_vm._v("Our workshop programme is also able to travel and we have delivered off-site workshops for Converse, Uniqlo and Facebook for group sizes ranging from 15–50.")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "gold-hover",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.scrollTo('contact')
      }
    }
  }, [_vm._v("Contact us →")])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h4', {
    staticClass: "gold"
  }, [_vm._v("Post and Pre Workshop")]), _vm._v(" "), _c('p', [_vm._v("Mulled wine and Christmas related snacks are provided for parties at Hato Press, we can also order in take away for you and your team. If you feel like a sit down meal and a nice glass of wine or hot toddy we have a few recommendations for you that are only a short wonder down the road. "), _c('a', {
    staticClass: "gold-hover",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.scrollTo('places')
      }
    }
  }, [_vm._v("Read the list")]), _vm._v(" we’ve put together for you.")])])])])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "christmas-intro content-wrapper"
  }, [_c('div', {
    staticClass: "content-text"
  }, [_c('h1', {
    staticClass: "gold"
  }, [_vm._v("\n          Hato Press"), _c('br'), _vm._v("\n          Christmas Parties\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "gold-light"
  }, [_vm._v("\n          For Christmas we offer special edition Risograph workshops, in the format of Christmas Card Making or Wrapping Paper workshops.\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "gold-light"
  }, [_vm._v("\n          It’s a great opportunity for your workplace christmas party that brings together learning through play methodologies, craft, mulled wine and a few ticks off of that Christmas shopping list.\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column mobile-order-0"
  }, [_c('img', {
    attrs: {
      "src": "https://assets.hato.co/b1/assets/workshops/Xmas-workshop_Kaneyasu_postcard_2019.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column mobile-order-0"
  }, [_c('img', {
    attrs: {
      "src": "https://assets.hato.co/b1/assets/workshops/Xmas-workshop_Kaneyasu_wrapping_2019.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    attrs: {
      "id": "images"
    }
  }, [_c('div', {
    staticClass: "content-text images"
  }, [_c('img', {
    staticClass: "image-intro",
    attrs: {
      "src": "https://assets.hato.co/b1/assets/workshops/HatoPress-Beams-introduction.jpeg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "image-drum",
    attrs: {
      "src": "https://assets.hato.co/b1/assets/workshops/HatoPress-Risograph-Workshop-Christmas-Riso-Machine.jpeg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "image-copy",
    attrs: {
      "src": "https://assets.hato.co/b1/assets/workshops/HatoPress-Beams-Copying-Image.jpeg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "image-artworking",
    attrs: {
      "src": "https://assets.hato.co/b1/assets/workshops/HatoPress-Risograph-Workshop-Christmas-Artworking.jpeg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n            Participants: Up to 15 people, but if you’d like to book in a few more we will do our best to accomodate"), _c('br'), _vm._v("\n            Dates: Throughout November and December"), _c('br'), _vm._v("\n            Timings: 2–2.5 hours, anytime between 12–9:30pm"), _c('br'), _vm._v("\n            Minimum cost £500 +VAT up to 4 people, then £100 +VAT thereafter per person.\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("If you think this option would suit you well, please get in touch at "), _c('a', {
    attrs: {
      "href": "mailto:bespoke@hatopress.net?subject=Hato%20Press%20Christmas%20Offer",
      "target": "_blank"
    }
  }, [_vm._v("bespoke@hatopress.net")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "christmas-action action content-wrapper",
    attrs: {
      "id": "contact"
    }
  }, [_c('div', {
    staticClass: "content-text"
  }, [_c('h2', {}, [_vm._v("\n        Contact Us\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "width-50"
  }, [_vm._v("\n        Interested in one of the options, or got a question? Let us know what you're looking for. We're happy to help.\n      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "mailto:bespoke@hatopress.net?subject=Hato%20Press%20Christmas%20Offer"
    }
  }, [_vm._v("bespoke@hatopress.net")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "tel:+44-207-729-5585"
    }
  }, [_vm._v("+44 (0)207 729 5585")]), _vm._v(" "), _c('img', {
    staticClass: "size-mid",
    attrs: {
      "src": "https://assets.hato.co/b1/assets/workshops/Xmas-workshop_Kaneyasu_riso_2019.png",
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "places content-wrapper",
    attrs: {
      "id": "places"
    }
  }, [_c('div', {
    staticClass: "content-text"
  }, [_c('h2', {}, [_vm._v("\n        Places Around Hato Press\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "width-50"
  }, [_vm._v("\n        Feel like a sit down meal and a nice glass of wine or hot toddy before or after your visit? We have a few recommendations for you:\n      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "two-columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h4', [_vm._v("Dinner")]), _vm._v(" "), _c('div', {
    staticClass: "place"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "https://www.marksmanpublichouse.com/",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v("The Marksman")])]), _vm._v(" Michelin Pub of the Year. Dining Room Upstairs designed by Martino Gamper, serving hearty British Food\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "place"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "http://thelaughingheartlondon.com/",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v("The Laughing Heart")])]), _vm._v(" European small plates with a list of speciality wines\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "place"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "https://www.moritohackneyroad.co.uk/",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v("Morito Hackney Road")])]), _vm._v(" sister restaurant to Moro on Exmouth Market, tapas dishes from Southern Spain to North Africa\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h4', [_vm._v("Drinks")]), _vm._v(" "), _c('div', {
    staticClass: "place"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "https://www.marksmanpublichouse.com/",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v("The Marksman")])]), _vm._v(" Michelin Pub of the Year. Dining Room Upstairs designed by Martino Gamper, serving hearty British Food\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "place"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "https://www.royaloaklondon.com/",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v("The Royal Oak")])]), _vm._v(" local gastropub with upstairs dining room\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "place"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "https://www.sagerandwilde.com/hackney-road/",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v("Sager + Wilde")])]), _vm._v(" local wine bar\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "place"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "http://sebrightarms.com/",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v("Sebright Arms")])]), _vm._v(" local pub with live music\n                ")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "action content-text"
  }, [_c('h2', {}, [_vm._v("\n        Get in touch to learn more about our regular and bespoke workshops, or any general enquiries on workshops.\n      ")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "mailto:learn@hatopress.net"
    }
  }, [_vm._v("learn@hatopress.net")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "tel:+44-207-729-5585"
    }
  }, [_vm._v("+44 (0)207 729 5585")])])
}]}

/***/ }),
/* 207 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 208 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workshops-courses"
  }, [_c('nav-1'), _vm._v(" "), _c('hero', {
    attrs: {
      "image": _vm.hero
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "contact-form"
  }, [_c('div', {
    staticClass: "size__content__narrow pos__content__center"
  }, [_c('mailchimp')], 1)]), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-text"
  }, [_c('h1', [_vm._v("Short Courses")]), _vm._v(" "), _c('h4', {
    staticClass: "size__content__narrow pos__content__center"
  }, [_vm._v("\n      Exciting news! We are curating a new course offering which provides a comprehensive and in-depth introduction to a range of design and printing techniques. Drawing on our vast experience, each workshop is conducted in small groups, ensuring maximum support and guidance from our experienced tutors.\n      "), _c('br'), _c('br'), _vm._v("\n      Sign up to register your interest\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "action-wrapper"
  }, [_c('div', {
    staticClass: "action"
  }, [_c('h3', [_vm._v("Get in touch to learn more about our courses, or any general enquiries on workshops.")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:learn@hatopress.net"
    }
  }, [_vm._v("learn@hatopress.net")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:+44-207-729-5585"
    }
  }, [_vm._v("+44 (0)207 729 5585")])])])
}]}

/***/ }),
/* 209 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('h2', [_vm._v("Gift vouchers are available for all classes")]), _vm._v(" "), _c('img', {
    staticClass: "gift-card",
    attrs: {
      "src": _vm.cardImage,
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "action"
  }, [_c('a', {
    attrs: {
      "href": "https://shop.hatopress.net/products/gift-card",
      "target": "_blank"
    }
  }, [_vm._v("Buy Now")])])
}]}

/***/ }),
/* 210 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "hero-wrapper",
    class: [_vm.fill]
  }, [(!_vm.isMobile()) ? _c('div', {
    staticClass: "iframe-wrapper"
  }, [_c('iframe', {
    attrs: {
      "src": _vm.video.source,
      "width": "640",
      "height": "360",
      "frameborder": "0",
      "webkitallowfullscreen": "",
      "mozallowfullscreen": "",
      "allowfullscreen": ""
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isMobile()) ? _c('div', {
    staticClass: "background",
    style: ({
      'backgroundImage': 'url(' + _vm.video.poster + ')'
    })
  }) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-text"
  }, [_c('div', {}, [_c('h2', [_vm._v("Learn with Hato")]), _vm._v(" "), _c('h3', [_vm._v("Learn through play and take your pick of these creative workshops – curated by us.")])])])
}]}

/***/ }),
/* 211 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('nav-main'), _vm._v(" "), _c('div', {
    staticClass: "router-view"
  }, [_c('router-view')], 1), _vm._v(" "), _c('hato-press-footer'), _vm._v(" "), _c('newsletter')], 1)
},staticRenderFns: []}

/***/ }),
/* 212 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "department"
  }, [_c('h4', [_vm._v("Hato Press")]), _vm._v(" "), _c('p', [_vm._v("217 Mare Street"), _c('br'), _vm._v("E8 3QE London")]), _vm._v(" "), _c('p', [_vm._v("+44 (0) 20 7729 5585"), _c('br'), _c('a', {
    attrs: {
      "href": "mailto:info@hatopress.net"
    }
  }, [_vm._v("info@hatopress.net")]), _c('br'), _c('a', {
    attrs: {
      "href": "https://instagram.com/hatopress",
      "target": "_blank"
    }
  }, [_vm._v("@hatopress")])])]), _vm._v(" "), _c('div', {
    staticClass: "department"
  }, [_c('h4', [_vm._v("Printing")]), _vm._v(" "), _c('p', [_vm._v("Got a question about the printing process or setting up your artwork?")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "mailto:info@hatopress.net"
    }
  }, [_vm._v("info@hatopress.net")])])]), _vm._v(" "), _c('div', {
    staticClass: "department"
  }, [_c('h4', [_vm._v("Workshops")]), _vm._v(" "), _c('p', [_vm._v("All our workshops are framed around our belief that having fun is the best way to learn something new.")]), _vm._v(" "), _c('p', [_vm._v("For workshop classes and general enquiry: "), _c('a', {
    attrs: {
      "href": "mailto:learn@hatopress.net"
    }
  }, [_vm._v("learn@hatopress.net")])]), _vm._v(" "), _c('p', [_vm._v("For bespoke workshops, strategy or partnership: "), _c('a', {
    attrs: {
      "href": "mailto:bespoke@hatopress.net"
    }
  }, [_vm._v("bespoke@hatopress.net")])])]), _vm._v(" "), _c('div', {
    staticClass: "department"
  }, [_c('h4', [_vm._v("Shop")]), _vm._v(" "), _c('p', [_vm._v("Get a copy of our latest books, prints, stationery and more.")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "mailto:shop@hatopress.net"
    }
  }, [_vm._v("shop@hatopress.net")])])])])])
}]}

/***/ }),
/* 213 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "size__content__default pos__content__center"
  }, [_c('form', {
    staticClass: "validate",
    attrs: {
      "action": "//hatopress.us3.list-manage.com/subscribe/post?u=756f2cd045a9c075f921c09f2&id=f6a7fab8aa",
      "method": "post",
      "id": "mc-embedded-subscribe-form",
      "name": "mc-embedded-subscribe-form",
      "target": "_blank",
      "novalidate": ""
    }
  }, [_c('h4', {}, [_vm._v("\n            Follow us and sign up to our newsletter\n          ")]), _vm._v(" "), _c('input', {
    staticClass: "email",
    attrs: {
      "type": "email",
      "value": "",
      "name": "EMAIL",
      "id": "mce-EMAIL",
      "placeholder": "Enter email address",
      "required": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "left": "-5000px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('input', {
    attrs: {
      "type": "text",
      "name": "b_756f2cd045a9c075f921c09f2_f6a7fab8aa",
      "tabindex": "-1",
      "value": ""
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "button",
    attrs: {
      "type": "submit",
      "value": "Subscribe",
      "name": "subscribe",
      "id": "mc-embedded-subscribe"
    }
  })])])])
}]}

/***/ }),
/* 214 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero-wrapper"
  }, [_c('div', {
    staticClass: "background",
    style: ({
      'backgroundImage': 'url(' + _vm.image + ')'
    })
  })])])
},staticRenderFns: []}

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workshops-bespoke"
  }, [_c('nav-1'), _vm._v(" "), _c('hero', {
    attrs: {
      "image": _vm.hero
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "products-wrapper"
  }, [_c('h2', [_vm._v("Sample Bespoke Workshops")]), _vm._v(" "), _c('div', {
    staticClass: "products size__content__wide pos__content__center"
  }, _vm._l((_vm.products), function(p, index) {
    return _c('div', {
      staticClass: "product"
    }, [_c('h2', {
      staticClass: "--flash",
      domProps: {
        "innerHTML": _vm._s(p.title)
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(p.text))]), _vm._v(" "), _c('ul', _vm._l((p.key), function(k) {
      return _c('li', [_vm._v(_vm._s(k))])
    })), _vm._v(" "), _vm._m(1, true)])
  })), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-text"
  }, [_c('h1', [_vm._v("Private & Corporate Workshops")]), _vm._v(" "), _c('h4', {
    staticClass: "size__content__default pos__content__center"
  }, [_vm._v("\n      A Learn with Hato workshop is a great way to celebrate an event or bring colleagues together. We have hosted zine-making, typeface design, terrarium-building and other creative workshops in the past. With an in-house team of design & printing experts and a network of creative collaborators, our curated experiences are tailored to your specific requirements – in‑house or offsite, analog or digital, party or masterclass. Take a look at these sample bespoke workshops:\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "action"
  }, [_c('a', {
    attrs: {
      "href": "mailto:bespoke@hatopress.net"
    }
  }, [_vm._v("Enquire")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "action"
  }, [_c('h3', [_vm._v("Not what you’re looking for? Let us customise your next event with a bespoke workshop.")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:bespoke@hatopress.net?subject=Bespoke Workshops"
    }
  }, [_vm._v("bespoke@hatopress.net")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:+44-207-729-5585"
    }
  }, [_vm._v("+44 (0)207 729 5585")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quotes size__content__wide pos__content__center"
  }, [_c('div', {
    staticClass: "quote"
  }, [_c('h3', [_vm._v("“Our creative team loved the chance to roll up our sleeves and learn risoprinting from one of the finest studios in London. The session was well run. Hats off to Hato.”")]), _vm._v(" "), _c('p', [_vm._v("Shirley, Senior Copywriter, Virgin Media")])]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('h3', [_vm._v("“The two colour workshop was perfect for our group to experiment and get creative. We learnt loads and would recommend to anyone!”")]), _vm._v(" "), _c('p', [_vm._v("Emma, Graphic Designer, Boden")])]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('h3', [_vm._v("“We have a great Riso printing session at Hato, really learnt a lot and was great fun. Was a great way to work on something different whilst enjoying a beer ;-).”")]), _vm._v(" "), _c('p', [_vm._v("Alex Prior, Head of Graphic Design at The Hoxton")])]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('h3', [_vm._v("“The Hato Christmas Card workshop was the perfect activity for the team to get out the office and learn and do something new together. The instructors were amazing, offering motivation and tips throughout. We came away with a new appreciation for the risograph print process, along with some fantastic printed cards (some showing more creative skill than others!).”")]), _vm._v(" "), _c('p', [_vm._v("Helen Scibilia, Project Manager, YCN")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-logos"
  }, [_c('img', {
    staticClass: "size__content__narrow",
    attrs: {
      "src": __webpack_require__(173),
      "alt": ""
    }
  })])
}]}

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workshops-bespoke"
  }, [_c('nav-1'), _vm._v(" "), _c('hero', {
    attrs: {
      "image": _vm.hero
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "carousel-wrapper"
  }, [_c('h4', {
    staticClass: "size__content__default pos__content__center"
  }, [_vm._v("\n      We have worked with clients across the art, commercial and education sectors and partnered with curators, brands and experts from other fields.\n    ")]), _vm._v(" "), _c('flickity', {
    ref: "flickity",
    staticClass: "carousel",
    attrs: {
      "options": _vm.flickityOptions
    }
  }, _vm._l((_vm.carousel), function(cell, index) {
    return _c('div', {
      staticClass: "carousel-cell"
    }, [_c('div', {
      staticClass: "carousel-media",
      style: ({
        'backgroundImage': 'url(' + cell.image + ')',
        'backgroundPosition': index === 2 ? 'top center' : 'bottom center'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "carousel-text"
    }, [_c('h4', [_vm._v(_vm._s(cell.text))])])])
  }))], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-text"
  }, [_c('h1', [_vm._v("Workshop Strategy & Partnership")]), _vm._v(" "), _c('h4', {
    staticClass: "size__content__default pos__content__center",
    attrs: {
      "xxxxxcontenteditable": ""
    }
  }, [_vm._v("\n      Beyond learning, workshops can serve as a powerful tool for brands and institutions to foster meaningful relationships with their customers. "), _vm._v(" Discover how our workshops can facilitate your event, exhibition programme or product launch to connect with your audience on a more engaging level. Whether it’s creating a cookbook via a workshop app, branding a festival or co-creating artworks with 400 children, we offer a full workshop strategy for:\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "strategy-list size__content__default pos__content__center"
  }, [_c('ul', {}, [_c('li', [_c('h4', [_vm._v("Exhibition programmes")])]), _vm._v(" "), _c('li', [_c('h4', [_vm._v("Education projects")])]), _vm._v(" "), _c('li', [_c('h4', [_vm._v("Experiential installations")])]), _vm._v(" "), _c('li', [_c('h4', [_vm._v("Brand activation")])]), _vm._v(" "), _c('li', [_c('h4', [_vm._v("Product launch experiences")])]), _vm._v(" "), _c('li', [_c('h4', [_vm._v("Events and festivals")])]), _vm._v(" "), _c('li', [_c('h4', [_vm._v("Community programmes")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quotes size__content__wide pos__content__center"
  }, [_c('div', {
    staticClass: "quote"
  }, [_c('h4', [_vm._v("“Hato led a risograph workshop for our partnership with The Conran Shop during LDF, we really enjoyed working with Hato on this project. They're super efficient, provided innovative concepts and a pleasure to work with!”")]), _vm._v(" "), _c('p', [_vm._v("Manda Wilks, Project Manager, It's Nice That")])]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('h4', [_vm._v("“Hato’s energy and enthusiasm for playing with printing led to an imaginative and fun day for families at the RA. Families colourfully reimagined abstract works guided by the Hato team which allowed parents and children to create in an exploratory way discovering new printing skills”")]), _vm._v(" "), _c('p', [_vm._v("Gwen Ramsay, Family Programmer, Royal Academy of Arts.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-logos"
  }, [_c('img', {
    staticClass: "size__content__narrow",
    attrs: {
      "src": __webpack_require__(174),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clients-wrapper"
  }, [_c('h4', {
    staticClass: "size__content__narrow pos__content__center"
  }, [_vm._v("\n      We have worked with clients across the art, commercial and education sectors and partnered with curators, brands, educators and experts from other fields.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "clients layout-b xxxlayout-a"
  }, [_c('div', [_c('h3', [_vm._v("It’s Nice That")]), _vm._v(" "), _c('p', [_vm._v("Strategy"), _c('br'), _vm._v("Brand Partnership")])]), _vm._v(" "), _c('div', [_c('h3', [_vm._v("Pick Me Up")]), _vm._v(" "), _c('p', [_vm._v("Festival Activation"), _c('br'), _vm._v("Strategy ")])]), _vm._v(" "), _c('div', [_c('h3', [_vm._v("Facebook")]), _vm._v(" "), _c('p', [_vm._v("Strategy"), _c('br'), _vm._v("Analog and Digital Engagement ")])]), _vm._v(" "), _c('div', [_c('h3', [_vm._v("Royal Academy")]), _vm._v(" "), _c('p', [_vm._v("Strategy"), _c('br'), _vm._v("Co-creation"), _c('br'), _vm._v("Exhibition")])]), _vm._v(" "), _c('div', [_c('h3', [_vm._v("Urban Outfitters")]), _vm._v(" "), _c('p', [_vm._v("Brand Partnership"), _c('br'), _vm._v("Strategy ")])]), _vm._v(" "), _c('div', [_c('h3', [_vm._v("Liverpool Biennial")]), _vm._v(" "), _c('p', [_vm._v("Education"), _c('br'), _vm._v("Community"), _c('br'), _vm._v("Co-design"), _c('br'), _vm._v("Digital Engagement")])]), _vm._v(" "), _c('div', [_c('h3', [_vm._v("The V&A")]), _vm._v(" "), _c('p', [_vm._v("Education")])]), _vm._v(" "), _c('div', [_c('h3', [_vm._v("University of Arts London")]), _vm._v(" "), _c('p', [_vm._v("Strategy")])]), _vm._v(" "), _c('div', [_c('h3', [_vm._v("Edgware Road Project")]), _vm._v(" "), _c('p', [_vm._v("Strategy"), _c('br'), _vm._v("Co-creation"), _c('br'), _vm._v("Exhibition")])]), _vm._v(" "), _c('div', [_c('h3', [_vm._v("Tate Exchange")]), _vm._v(" "), _c('p', [_vm._v("Education"), _c('br'), _vm._v("Strategy"), _c('br'), _vm._v("Publishing")])]), _vm._v(" "), _c('div', [_c('h3', [_vm._v("British Council")]), _vm._v(" "), _c('p', [_vm._v("Strategy"), _c('br'), _vm._v("Co-creation"), _c('br'), _vm._v("Exhibition")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "action-wrapper"
  }, [_c('div', {
    staticClass: "action"
  }, [_c('h3', [_vm._v("Get in touch to learn more about our bespoke workshops, or any general enquiries on workshops.")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:bespoke@hatopress.net?subject=Strategy and Partnership"
    }
  }, [_vm._v("bespoke@hatopress.net")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:+44-207-729-5585"
    }
  }, [_vm._v("+44 (0)207 729 5585")])])])
}]}

/***/ }),
/* 217 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 218 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "play",
    on: {
      "click": _vm.yo
    }
  }, [_c('svg', {
    attrs: {
      "id": "play",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "1000",
      "height": "1000",
      "viewBox": "0 0 1000 1000"
    }
  }, [_c('title', [_vm._v("play")]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Layer_2",
      "data-name": "Layer 2"
    }
  }, [_c('rect', {
    staticStyle: {
      "fill": "none"
    },
    attrs: {
      "width": "1000",
      "height": "1000"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Layer_1",
      "data-name": "Layer 1"
    }
  }, [_c('path', {
    staticStyle: {
      "fill": "none"
    },
    attrs: {
      "id": "Y",
      "d": "M835.10411,570.82564,709.06139,771.27937,569.351,570.82564M709.06092,926.55522V771.27949"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "none"
    },
    attrs: {
      "id": "A",
      "d": "M143.40182,924.2773,292.22357,573.10356h14.04694L456.61083,924.2773m-237.27955-175.397H380.6814"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "none"
    },
    attrs: {
      "id": "L",
      "d": "M821.06073,436.12287H583.16792V84.94912"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "none"
    },
    attrs: {
      "id": "P",
      "d": "M177.41085,439.072V86H327.5732a94.53216,94.53216,0,1,1,0,189.06431H181.20732"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workshops-bespoke"
  }, [_c('nav-1'), _vm._v(" "), _c('play'), _vm._v(" "), _c('h1', [_vm._v("\n      Playtotype™ Workshops\n    ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content-text playtotype-info-wrapper",
    class: {
      'expanded': _vm.expand
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h5', {
    staticClass: "what-is",
    on: {
      "click": function($event) {
        _vm.expand = !_vm.expand
      }
    }
  }, [(!_vm.expand) ? _c('span', [_vm._v("Read More about Playtotype™")]) : _vm._e(), _vm._v(" "), (_vm.expand) ? _c('span', [_vm._v("Close")]) : _vm._e()]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "size__content__narrow pos__content__center playtotype-info"
  }, [_c('p', [_vm._v("Playtotyping™ is our approach and method of working. It engages and spurs people to play in order to solve a problem or answer a brief or quite simply to have fun and be creative.")]), _vm._v(" "), _c('p', [_vm._v("We use design, craft and technology to give people the tools to connect with their inherent creativity, to express their ideas and collaborate with each other.")]), _vm._v(" "), _c('p', [_vm._v("The overall aim of playtotyping™ is to move and inspire communities, clients and individuals to innovate and create new ways of thinking and doing through the art of play.")]), _vm._v(" "), _c('p', [_vm._v("At HATO we believe that being playful and creative are part of the everyday. We use this ethos throughout our own practice. Through our public and private workshops programme we are able to engage others to do the same.")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.diagram,
      "alt": ""
    }
  })])]), _vm._v(" "), _c('figure', {
    staticClass: "media full"
  }, [_c('img', {
    attrs: {
      "src": _vm.onpress,
      "alt": ""
    }
  }), _vm._v(" "), _c('figcaption', [_vm._v("ON PRESS at Selfridges")])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "content-text download"
  }, [_c('div', {
    staticClass: "action"
  }, [_c('h4', [_vm._v("Find out more about prices and tailored packages")]), _vm._v(" "), _c('a', {
    staticClass: "icon",
    attrs: {
      "href": "../static/Hato-Bespoke-Workshops-Package-June-2019.pdf",
      "target": "_blank"
    }
  }, [_c('svg', {
    attrs: {
      "width": "22px",
      "height": "24px",
      "viewBox": "0 0 22 24",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Page-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "-",
      "transform": "translate(-5.000000, -4.000000)",
      "stroke": "#000000",
      "stroke-width": "2",
      "fill": "none"
    }
  }, [_c('polyline', {
    attrs: {
      "id": "Rectangle",
      "transform": "translate(15.949747, 18.449747) rotate(-315.000000) translate(-15.949747, -18.449747) ",
      "points": "19.4497475 14.9497475 19.4497475 21.9497475 12.4497475 21.9497475"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16,23 L16,5.90987723",
      "id": "Line",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M6.5,27 L25.2871094,27",
      "id": "Line-2",
      "stroke-linecap": "square"
    }
  })])])]), _vm._v(" "), _c('span', [_vm._v("Download Information Pack")])])])]), _vm._v(" "), _c('div', {
    staticClass: "carousel-wrapper testimonials"
  }, [_c('h2', [_vm._v("What our clients say")]), _vm._v(" "), _c('flickity', {
    ref: "flickity",
    staticClass: "carousel",
    attrs: {
      "options": _vm.flickityOptions
    }
  }, [_c('div', {
    staticClass: "carousel-cell"
  }, [_c('div', {
    staticClass: "quote"
  }, [_c('h3', [_vm._v("“Hato’s energy and enthusiasm for playing with printing led to an imaginative and fun day for families at the RA.”")]), _vm._v(" "), _c('p', [_vm._v("Gwen Ramsay, Family Programmer, Royal Academy of Arts.")])])]), _vm._v(" "), _c('div', {
    staticClass: "carousel-cell"
  }, [_c('div', {
    staticClass: "quote"
  }, [_c('h3', [_vm._v("“Our creative team loved the chance to roll up our sleeves and learn risoprinting from one of the finest studios in London. The session was well run. Hats off to Hato.”")]), _vm._v(" "), _c('p', [_vm._v("Shirley, Senior Copywriter, Virgin Media")])])]), _vm._v(" "), _c('div', {
    staticClass: "carousel-cell"
  }, [_c('div', {
    staticClass: "quote"
  }, [_c('h3', [_vm._v("“The two colour workshop was perfect for our group to experiment and get creative. We learnt loads and would recommend to anyone!”")]), _vm._v(" "), _c('p', [_vm._v("Emma, Graphic Designer, Boden")])])]), _vm._v(" "), _c('div', {
    staticClass: "carousel-cell"
  }, [_c('div', {
    staticClass: "quote xl"
  }, [_c('h3', [_vm._v("“The Hato Christmas Card workshop was the perfect activity for the team to get out the office and learn and do something new together. The instructors were amazing, offering motivation and tips throughout. We came away with a new appreciation for the risograph print process, along with some fantastic printed cards (some showing more creative skill than others!).”")]), _vm._v(" "), _c('p', [_vm._v("Helen Scibilia, Project Manager, YCN")])])]), _vm._v(" "), _c('div', {
    staticClass: "carousel-cell"
  }, [_c('div', {
    staticClass: "quote"
  }, [_c('h3', [_vm._v("“We have a great Riso printing session at Hato, really learnt a lot and was great fun. Was a great way to work on something different whilst enjoying a beer ;-).”")]), _vm._v(" "), _c('p', [_vm._v("Alex Prior, Head of Graphic Design at The Hoxton")])])])])], 1), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "content-text cta"
  }, [_c('div', {
    staticClass: "action"
  }, [_c('h3', [_vm._v("Let's begin.")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:bespoke@hatopress.net?subject=Bespoke Workshops"
    }
  }, [_vm._v("bespoke@hatopress.net")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:+44-207-729-5585"
    }
  }, [_vm._v("+44 (0)207 729 5585")]), _vm._v(" "), _c('a', {
    staticClass: "icon",
    attrs: {
      "href": "../static/Hato-Bespoke-Workshops-Package-June-2019.pdf",
      "target": "_blank"
    }
  }, [_c('svg', {
    attrs: {
      "width": "22px",
      "height": "24px",
      "viewBox": "0 0 22 24",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Page-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "-",
      "transform": "translate(-5.000000, -4.000000)",
      "stroke": "#000000",
      "stroke-width": "2",
      "fill": "none"
    }
  }, [_c('polyline', {
    attrs: {
      "id": "Rectangle",
      "transform": "translate(15.949747, 18.449747) rotate(-315.000000) translate(-15.949747, -18.449747) ",
      "points": "19.4497475 14.9497475 19.4497475 21.9497475 12.4497475 21.9497475"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16,23 L16,5.90987723",
      "id": "Line",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M6.5,27 L25.2871094,27",
      "id": "Line-2",
      "stroke-linecap": "square"
    }
  })])])]), _vm._v(" "), _c('span', [_vm._v("Download Information Pack")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-text"
  }, [_c('h4', {
    staticClass: "size__content__default pos__content__center"
  }, [_vm._v("\n        At HATO we move and inspire communities, clients and individuals to innovate and create new ways of thinking and doing- through the art of play. Our Playtotype™ programme is designed to engage your teams and audiences to do the same.\n      ")]), _vm._v(" "), _c('h4', {
    staticClass: "size__content__default pos__content__center"
  }, [_vm._v("\n        Playtotyping™ is our approach and method of working. It engages and spurs people to play in order to solve a problem or answer a brief or quite simply to have fun and be creative.\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("\n          Playtotype™\n          "), _c('small', [_vm._v("Play as a Method of Working")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row col-2 size__content__default pos__content__center workshops"
  }, [_c('div', {
    staticClass: "exp-workshop workshop"
  }, [_c('h2', [_vm._v("Experiential Workshops at Hato Press")]), _vm._v(" "), _c('p', [_vm._v("Our experiential workshops are built around teams and groups wanting to explore play and creativity in a fun and inspiring way. Either hosted at our East London studio or at your own space be it your office/studio or temporary space, our team of workshop leaders and printers are able to devise tailored Riso printing and image making sessions that inspire new perspectives amongst teams and ensure a fun and engaging social event. ")]), _vm._v(" "), _c('h5', [_vm._v("Outcomes")]), _vm._v(" "), _c('div', {
    staticClass: "outcomes-boxes"
  }, [_c('div', {
    staticClass: "outcomes-box"
  }, [_vm._v("\n            Creative Thinking\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "outcomes-box"
  }, [_vm._v("\n            Innovation\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "outcomes-box"
  }, [_vm._v("\n            Kinesthetic Learning\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "outcomes-box"
  }, [_vm._v("\n            Collaboration\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "outcomes-box"
  }, [_vm._v("\n            Team Building\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "outcomes-box"
  }, [_vm._v("\n            Visual Learning\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "bes-workshop workshop"
  }, [_c('h2', [_vm._v("Bespoke Workshops"), _c('br'), _vm._v("for Events")]), _vm._v(" "), _c('p', [_vm._v("Our Bespoke workshops are a chance for your organisation and brand to bring a new level of engagement and fun to an event or brand activation. ")]), _vm._v(" "), _c('p', [_vm._v("The format and type of bespoke workshop varies greatly, from Riso printing in a department store window to Calligraphy for a retail pop-up, our team can help tailor an activation that will suit your needs and messaging.")]), _vm._v(" "), _c('h5', [_vm._v("Outcomes")]), _vm._v(" "), _c('div', {
    staticClass: "outcomes-boxes"
  }, [_c('div', {
    staticClass: "outcomes-box"
  }, [_vm._v("\n            Consumer"), _c('br'), _vm._v("Engagement\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "outcomes-box"
  }, [_vm._v("\n            New"), _c('br'), _vm._v("Audiences\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "outcomes-box"
  }, [_vm._v("\n            Bespoke Artist"), _c('br'), _vm._v("Collaborations\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "outcomes-box"
  }, [_vm._v("\n            Targeted Brand"), _c('br'), _vm._v("Messaging\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "outcomes-box"
  }, [_vm._v("\n            Product"), _c('br'), _vm._v("Launches\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "outcomes-box"
  }, [_vm._v("\n            Digital and"), _c('br'), _vm._v("social awareness\n          ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-logos"
  }, [_c('img', {
    staticClass: "size__content__narrow",
    attrs: {
      "src": __webpack_require__(54),
      "alt": ""
    }
  })])
}]}

/***/ }),
/* 220 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('h1', {
    ref: "timetable"
  }, [_vm._v("\n    Workshop timetable\n  ")]), _vm._v(" "), (!_vm.workshops) ? _c('div', {
    staticClass: "loading"
  }, [_vm._v("\n    Loading workshops...\n  ")]) : _vm._e(), _vm._v(" "), (_vm.workshops && _vm.workshops.length <= 0) ? _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "notification"
  }, [_vm._v("\n      All workshops have been postponed until futher notice\n    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "blurred filter-wrapper",
    class: {
      'workshop-filter-active': _vm.workshopFilterActive
    }
  }, [_c('div', {
    staticClass: "filters"
  }, [(_vm.workshops && _vm.workshops.length > 0) ? _c('div', {
    staticClass: "filter"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Type:")]), _vm._v(" "), _c('a', {
    key: 'all',
    class: {
      'active': _vm.workshopTypeFilter === ''
    },
    on: {
      "click": function($event) {
        _vm.workshopTypeFilter = ''
      }
    }
  }, [_vm._v("All Workshops")]), _vm._v(" "), _vm._l((_vm.typesOfWorkshops), function(type) {
    return _c('a', {
      key: type,
      class: {
        'active': _vm.workshopTypeFilter === type
      },
      on: {
        "click": function($event) {
          _vm.workshopTypeFilter = type
        }
      }
    }, [_vm._v("\n          " + _vm._s(type) + "\n        ")])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.workshops && _vm.workshops.length > 0) ? _c('div', {
    staticClass: "filter"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Dates:")]), _vm._v(" "), _c('a', {
    key: 'all',
    class: {
      'active': _vm.workshopMonthFilter === ''
    },
    on: {
      "click": function($event) {
        _vm.workshopMonthFilter = ''
      }
    }
  }, [_vm._v("All Dates")]), _vm._v(" "), _vm._l((_vm.monthsOfWorkshops), function(month) {
    return _c('a', {
      key: month,
      class: {
        'active': _vm.workshopMonthFilter === month
      },
      on: {
        "click": function($event) {
          _vm.workshopMonthFilter = month
        }
      }
    }, [_vm._v(_vm._s(month))])
  })], 2) : _vm._e()]), _vm._v(" "), (_vm.workshops && _vm.workshops.length > 0) ? _c('div', {
    staticClass: "filter-display"
  }, [(!_vm.workshopTypeFilter && !_vm.workshopMonthFilter) ? _c('div', {}, [_vm._v("\n        Showing all up coming workshops\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.workshopTypeFilter && _vm.workshopMonthFilter) ? _c('div', {}, [_vm._v("\n        Showing all workshops in " + _vm._s(_vm.workshopMonthFilter) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.workshopTypeFilter && !_vm.workshopMonthFilter) ? _c('div', {}, [_vm._v("\n        Showing all up coming " + _vm._s(_vm.getFilterTypeName(_vm.workshopTypeFilter)) + " workshops\n      ")]) : _vm._e(), _vm._v(" "), (_vm.workshopTypeFilter && _vm.workshopMonthFilter) ? _c('div', {}, [_vm._v("\n        Showing " + _vm._s(_vm.getFilterTypeName(_vm.workshopTypeFilter)) + " workshops in " + _vm._s(_vm.workshopMonthFilter) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "filter-display-action",
    on: {
      "click": function($event) {
        _vm.workshopFilterActive = !_vm.workshopFilterActive
      }
    }
  }, [(_vm.workshopFilterActive) ? _c('span', [_vm._v("Hide Filters")]) : _vm._e(), _vm._v(" "), (!_vm.workshopFilterActive) ? _c('span', [_vm._v("Show Filters")]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), (_vm.workshops && _vm.workshops.length > 0) ? _c('div', {
    staticClass: "filter-display",
    class: {
      'workshop-filter-active': _vm.workshopFilterActive
    }
  }, [(!_vm.workshopTypeFilter && !_vm.workshopMonthFilter) ? _c('div', {}, [_vm._v("\n      Showing all up coming workshops\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.workshopTypeFilter && _vm.workshopMonthFilter) ? _c('div', {}, [_vm._v("\n      Showing all workshops in " + _vm._s(_vm.workshopMonthFilter) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.workshopTypeFilter && !_vm.workshopMonthFilter) ? _c('div', {}, [_vm._v("\n      Showing all up coming " + _vm._s(_vm.getFilterTypeName(_vm.workshopTypeFilter)) + " workshops\n    ")]) : _vm._e(), _vm._v(" "), (_vm.workshopTypeFilter && _vm.workshopMonthFilter) ? _c('div', {}, [_vm._v("\n      Showing " + _vm._s(_vm.getFilterTypeName(_vm.workshopTypeFilter)) + " workshops in " + _vm._s(_vm.workshopMonthFilter) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "filter-display-action",
    on: {
      "click": function($event) {
        _vm.workshopFilterActive = !_vm.workshopFilterActive
      }
    }
  }, [(_vm.workshopFilterActive) ? _c('span', [_vm._v("Hide Filters")]) : _vm._e(), _vm._v(" "), (!_vm.workshopFilterActive) ? _c('span', [_vm._v("Show Filters")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('transition-group', {
    staticClass: "listings",
    class: {
      'workshop-filtering': _vm.workshopFilteringInProgress
    },
    attrs: {
      "name": "",
      "tag": "div"
    }
  }, [((_vm.workshops && _vm.workshops.length > 0) && (_vm.computedWorkshops && _vm.computedWorkshops.length == 0)) ? _c('div', {
    key: 'no-results',
    staticClass: "filter-empty"
  }, [_vm._v("\n      No matching results\n      "), _c('br'), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.workshopTypeFilter = ''
      }
    }
  }, [_vm._v("Browse all workshops in " + _vm._s(_vm.workshopMonthFilter))]), _vm._v(" or "), _c('a', {
    on: {
      "click": function($event) {
        _vm.workshopMonthFilter = ''
      }
    }
  }, [_vm._v("Browse all " + _vm._s(_vm.getFilterTypeName(_vm.workshopTypeFilter)) + " workshops")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.computedWorkshops), function(workshop, index) {
    return (_vm.workshops && _vm.workshops.length > 0) ? _c('div', {
      key: workshop.node.id,
      staticClass: "listing list-complete-item"
    }, [_c('div', {
      staticClass: "listing-content"
    }, [_c('div', {
      staticClass: "image"
    }), _vm._v(" "), _c('div', {
      staticClass: "info"
    }, [_c('h3', {
      domProps: {
        "innerHTML": _vm._s(workshop.productTitle)
      }
    }), _vm._v(" "), _c('div', [_vm._v(_vm._s(workshop.productDate))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(workshop.productTime))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(workshop.productPrice))])]), _vm._v(" "), _c('div', {
      staticClass: "action"
    }, [_c('a', {
      attrs: {
        "href": workshop.productUrl
      }
    }, [_vm._v("Details →")]), _vm._v(" "), _c('div', {
      staticClass: "status"
    }, [(!(workshop.productAvailableForSale)) ? _c('span', [_vm._v("Sold Out")]) : _vm._e()])])])]) : _vm._e()
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 221 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNav1),
      expression: "showNav1"
    }],
    staticClass: "sticky",
    class: {
      'mobile': _vm.windowWidth < 1024,
        'desktop': _vm.windowWidth >= 1024
    },
    style: ({
      'background': _vm.bg
    })
  }, [_c('nav', [_c('div', {
    staticClass: "lwh"
  }, [_vm._v("\n      Learn with Hato\n    ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "exact": "",
      "to": '/' + _vm.urlSuffix
    }
  }, [(_vm.windowWidth >= 1024) ? _c('span', [_vm._v("Individual Workshops")]) : _vm._e(), _vm._v(" "), (_vm.windowWidth < 1024) ? _c('span', [_vm._v("Workshops")]) : _vm._e()]), _vm._v(" "), _c('router-link', {
    attrs: {
      "exact": "",
      "to": 'playtotype' + _vm.urlSuffix
    }
  }, [(_vm.windowWidth >= 1024) ? _c('span', [_vm._v("Playtotype™ Workshops")]) : _vm._e(), _vm._v(" "), (_vm.windowWidth < 1024) ? _c('span', [_vm._v("Playtotype™")]) : _vm._e()])], 1)])
},staticRenderFns: []}

/***/ }),
/* 222 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carousel-wrapper bg-light"
  }, [_c('flickity', {
    ref: "flickity",
    staticClass: "carousel",
    attrs: {
      "options": _vm.flickityOptions
    }
  }, [_c('div', {
    staticClass: "carousel-cell"
  }, [_c('div', {
    staticClass: "carousel-media"
  }, [_c('hero-video', {
    attrs: {
      "size": '65%',
      "fill": 'cover'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "carousel-text"
  })]), _vm._v(" "), _vm._l((_vm.workshops), function(cell, index) {
    return _c('div', {
      key: index,
      staticClass: "carousel-cell"
    }, [_c('div', {
      staticClass: "carousel-media",
      style: ({
        'backgroundImage': 'url(' + cell.productImage.transformedSrc + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "carousel-text"
    }, [_c('p', {
      staticClass: "workshop-title",
      domProps: {
        "innerHTML": _vm._s(cell.productTitle)
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "workshop-date",
      domProps: {
        "innerHTML": _vm._s(cell.productDate)
      }
    }), _vm._v(" "), (cell.productUrl) ? _c('a', {
      attrs: {
        "href": cell.productUrl
      }
    }, [_vm._v("Details →")]) : _vm._e()])])
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 223 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "bg bg1"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg bg2"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h2', [_vm._v("Christmas Workshops for Groups or Teams")]), _vm._v(" "), _vm._m(0), _c('div', {
    staticClass: "action"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Christmas'
      }
    }
  }, [_vm._v("Find out more")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Looking for workshops for your team or a group of friends? Contact us at "), _c('a', {
    attrs: {
      "href": "mailto:learn@hatopress.net?subject=Christmas+Group+Workshop"
    }
  }, [_vm._v("learn@hatopress.net")]), _vm._v(" or find out what we're offering"), _c('br'), _c('br')])
}]}

/***/ }),
/* 224 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('h2', [_vm._v("Check out how you could #learnwithhato and create something great")]), _vm._v(" "), _c('div', {
    staticClass: "listings"
  }, _vm._l((_vm.instagrams.slice(0, 8)), function(ig) {
    return _c('div', {
      key: ig.url,
      staticClass: "listing"
    }, [_c('a', {
      attrs: {
        "href": ig.url,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "image",
      style: ({
        'backgroundImage': 'url(' + ig.thumbnail + ')'
      })
    })])])
  }))])
},staticRenderFns: []}

/***/ }),
/* 225 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workshops-regular"
  }, [_c('nav-1', {
    attrs: {
      "bg": 'hsl(38, 63%, 75%)'
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "workshops content-wrapper"
  }, [_c('div', {
    staticClass: "content-text"
  }, [_c('div', {
    staticClass: "two-columns vertical-centerd"
  }, [_c('div', {
    staticClass: "column mobile-order-1"
  }, [_c('h4', {
    staticClass: "gold"
  }, [_vm._v("Christmas Card Making Workshop")]), _vm._v(" "), _c('p', [_vm._v("We’re encouraging you to get personal this Yuletide with some creative card-making to send to your nearest and dearest. We’ll take you behind the scenes at our printing studio, packed with different paper stock, riso drums and colourful ink tubes. Then it’s time to experiment using a mixture of collage and mark-making techniques where you will create 20 creased A6 cards, printed in 2 colours on our risograph printers.")]), _vm._v(" "), _c('a', {
    staticClass: "gold-hover",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.scrollTo('prices')
      }
    }
  }, [_vm._v("View Options →")])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "two-columns vertical-centerd"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "column mobile-order-1"
  }, [_c('h4', {
    staticClass: "gold"
  }, [_vm._v("Wrapping Paper Workshop")]), _vm._v(" "), _c('p', [_vm._v("Rubbish at buying presents? Always seem to get it wrong? Well, we can’t help you there. What we can do, however, is to make that slightly average gift look utterly spectacular. All you need is good wrapping paper. Hato Press will teach you a lesson in pattern-making so that you can design and print your own bespoke wrap. 20 folded A2 sheets of beautifully printed riso that guarantees to make that pair of cotton socks seem unusually desirable.")]), _vm._v(" "), _c('a', {
    staticClass: "gold-hover",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.scrollTo('prices')
      }
    }
  }, [_vm._v("View Options →")])])])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "prices content-wrapper",
    attrs: {
      "id": "prices"
    }
  }, [_c('div', {
    staticClass: "content-text"
  }, [_c('div', {
    staticClass: "two-columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h4', {
    staticClass: "gold"
  }, [_vm._v("Prices Per Party")]), _vm._v(" "), _c('p', [_vm._v("Chose from either Christmas Card Making or Wrapping Paper Workshops.")]), _vm._v(" "), _c('h5', {
    staticClass: "gold"
  }, [_vm._v("Parties at Hato Press")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('h5', {
    staticClass: "gold"
  }, [_vm._v("Hato Press comes to you")]), _vm._v(" "), _c('p', [_vm._v("Our workshop programme is also able to travel and we have delivered off-site workshops for Converse, Uniqlo and Facebook for group sizes ranging from 15–50.")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "gold-hover",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.scrollTo('contact')
      }
    }
  }, [_vm._v("Contact us →")])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h4', {
    staticClass: "gold"
  }, [_vm._v("Post and Pre Workshop")]), _vm._v(" "), _c('p', [_vm._v("Mulled wine and Christmas related snacks are provided for parties at Hato Press, and we can also order in take away for you and your team. If you feel like a sit down meal and a nice glass of wine or hot toddy we have a few recommendations for you that are only a short wonder down the road. "), _c('a', {
    staticClass: "gold-hover",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.scrollTo('places')
      }
    }
  }, [_vm._v("Read the list")]), _vm._v(" we’ve put together for you.")])])])])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "christmas-intro content-wrapper"
  }, [_c('div', {
    staticClass: "content-text"
  }, [_c('h1', {
    staticClass: "gold"
  }, [_vm._v("\n          Hato Press"), _c('br'), _vm._v("\n          Christmas Parties\n        ")]), _vm._v(" "), _c('h4', [_vm._v("\n          For Christmas we offer special edition Risograph workshops, in the format of Christmas Card Making or Wrapping Paper workshops.\n        ")]), _vm._v(" "), _c('h4', [_vm._v("\n          It’s a great opportunity for your workplace christmas party that brings together learning through play methodologies, craft, mulled wine and a few ticks off of that Christmas shopping list.\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column mobile-order-0"
  }, [_c('img', {
    attrs: {
      "src": "https://assets.hato.co/b1/assets/workshops/Xmas-workshop_Kaneyasu_postcard_2018.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column mobile-order-0"
  }, [_c('img', {
    attrs: {
      "src": "https://assets.hato.co/b1/assets/workshops/Xmas-workshop_Kaneyasu_wrapping_2018.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    attrs: {
      "id": "images"
    }
  }, [_c('div', {
    staticClass: "content-text images"
  }, [_c('img', {
    staticClass: "image-intro",
    attrs: {
      "src": "https://assets.hato.co/b1/assets/workshops/HatoPress-Beams-introduction.jpeg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "image-drum",
    attrs: {
      "src": "https://assets.hato.co/b1/assets/workshops/HatoPress-Risograph-Workshop-Christmas-Riso-Machine.jpeg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "image-copy",
    attrs: {
      "src": "https://assets.hato.co/b1/assets/workshops/HatoPress-Beams-Copying-Image.jpeg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "image-artworking",
    attrs: {
      "src": "https://assets.hato.co/b1/assets/workshops/HatoPress-Risograph-Workshop-Christmas-Artworking.jpeg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n            Participants: Up to 18 people, but if you’d like to book in a few more we will do our best to accomodate"), _c('br'), _vm._v("\n            Dates: Throughout December"), _c('br'), _vm._v("\n            Timings: 2–2.5 hours, Midday–9:30pm"), _c('br'), _vm._v("\n            Minimum cost £500 +VAT up to 4 people, then £100 +VAT thereafter per person.\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("If you think this option would suit you well, please get in touch at "), _c('a', {
    attrs: {
      "href": "mailto:learn@hatopress.net?subject=Hato%20Press%20Christmas%20Offer",
      "target": "_blank"
    }
  }, [_vm._v("learn@hatopress.net")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "christmas-action action content-wrapper",
    attrs: {
      "id": "contact"
    }
  }, [_c('div', {
    staticClass: "content-text"
  }, [_c('h2', {}, [_vm._v("\n        Contact Us\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "width-50"
  }, [_vm._v("\n        Interested in one of the options, or got a question? Let us know what you're looking for. We're happy to help.\n      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "mailto:learn@hatopress.net?subject=Hato%20Press%20Christmas%20Offer"
    }
  }, [_vm._v("learn@hatopress.net")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "tel:+44-207-729-5585"
    }
  }, [_vm._v("+44 (0)207 729 5585")]), _vm._v(" "), _c('img', {
    staticClass: "size-mid",
    attrs: {
      "src": "https://assets.hato.co/b1/assets/workshops/Xmas-workshop_Kaneyasu_riso_2018.png",
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "places content-wrapper",
    attrs: {
      "id": "places"
    }
  }, [_c('div', {
    staticClass: "content-text"
  }, [_c('h2', {}, [_vm._v("\n        Places Around Hato Press\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "width-50"
  }, [_vm._v("\n        Feel like a sit down meal and a nice glass of wine or hot toddy before or after your visit? We have a few recommendations for you:\n      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "two-columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h4', [_vm._v("Dinner")]), _vm._v(" "), _c('div', {
    staticClass: "place"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "https://www.marksmanpublichouse.com/",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v("The Marksman")])]), _vm._v(" Michelin Pub of the Year. Dining Room Upstairs designed by Martino Gamper, serving hearty British Food\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "place"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "http://thelaughingheartlondon.com/",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v("The Laughing Heart")])]), _vm._v(" European small plates with a list of speciality wines\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "place"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "https://www.moritohackneyroad.co.uk/",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v("Morito Hackney Road")])]), _vm._v(" sister restaurant to Moro on Exmouth Market, tapas dishes from Southern Spain to North Africa\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h4', [_vm._v("Drinks")]), _vm._v(" "), _c('div', {
    staticClass: "place"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "https://www.marksmanpublichouse.com/",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v("The Marksman")])]), _vm._v(" Michelin Pub of the Year. Dining Room Upstairs designed by Martino Gamper, serving hearty British Food\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "place"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "https://www.royaloaklondon.com/",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v("The Royal Oak")])]), _vm._v(" local gastropub with upstairs dining room\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "place"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "https://www.sagerandwilde.com/hackney-road/",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v("Sager + Wilde")])]), _vm._v(" local wine bar\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "place"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "http://sebrightarms.com/",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v("Sebright Arms")])]), _vm._v(" local pub with live music\n                ")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "action content-text"
  }, [_c('h2', {}, [_vm._v("\n        Get in touch to learn more about our regular and bespoke workshops, or any general enquiries on workshops.\n      ")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "mailto:learn@hatopress.net"
    }
  }, [_vm._v("learn@hatopress.net")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "tel:+44-207-729-5585"
    }
  }, [_vm._v("+44 (0)207 729 5585")])])
}]}

/***/ }),
/* 226 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "mc_embed_signup"
    }
  }, [_c('form', {
    staticClass: "validate",
    attrs: {
      "action": "//hatopress.us3.list-manage.com/subscribe/post?u=756f2cd045a9c075f921c09f2&id=0e2446d47f",
      "method": "post",
      "id": "mc-embedded-subscribe-form",
      "name": "mc-embedded-subscribe-form",
      "target": "_blank",
      "novalidate": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "mc_embed_signup_scroll"
    }
  }, [_c('input', {
    staticClass: "email",
    attrs: {
      "type": "email",
      "value": "",
      "name": "EMAIL",
      "id": "mce-EMAIL",
      "placeholder": "Enter email address",
      "required": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "left": "-5000px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('input', {
    attrs: {
      "type": "text",
      "name": "b_756f2cd045a9c075f921c09f2_0e2446d47f",
      "tabindex": "-1",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "SOURCE",
      "tabindex": "-1",
      "value": "Embed Form workshops.hatopress.net"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }, [_c('input', {
    staticClass: "button",
    attrs: {
      "type": "submit",
      "value": "Sign up",
      "name": "subscribe",
      "id": "mc-embedded-subscribe"
    }
  })])])])])
}]}

/***/ }),
/* 227 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    class: {
      'expanded': _vm.headerExpanded
    }
  }, [_c('div', {
    staticClass: "mobile-nav-click",
    on: {
      "click": function($event) {
        _vm.headerExpanded = !_vm.headerExpanded
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mobile-nav-menu",
    domProps: {
      "innerHTML": _vm._s(_vm.headerExpanded ? 'Close' : 'Menu')
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('a', {
    attrs: {
      "href": "https://hatopress.net"
    }
  }, [_vm._v("\n        Hato Press\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', [_c('a', {
    attrs: {
      "href": "https://hatopress.net/printing"
    }
  }, [_vm._v("Printing")]), _vm._v(" "), _c('a', [_vm._v("Workshops")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://shop.hatopress.net"
    }
  }, [_vm._v("Shop")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://hatopress.net/news"
    }
  }, [_vm._v("Journal")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://hatopress.net/about/"
    }
  }, [_vm._v("About")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://hatopress.net/contact/"
    }
  }, [_vm._v("Contact")])])
}]}

/***/ }),
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[63]);


// WEBPACK FOOTER //
// static/js/app.6110f997fc8a29334434.js